const messages = {
        he: {
          translations: {
            common: {
              yes: "כן",
              no: "לא",
              clean: "נקה",
              connection: "חיבור"
            },
            enterprisePlan: {
              title: "Enterprise",
              pricing: "תמחור מותאם אישית",
              description: "תוכנית מותאמת לצוותים בנפח גבוה",
              ctaContactSales: "צור קשר עם המכירות"
            },
            buttons: {
              cancel: "ביטול",
              close: "סגור",
              save: "שמור",
              confirm: "אישור",
              ok: "אישור",
              import: "ייבוא",
              all: "הכל"
            },
            signup: {
              title: "הרשם",
              toasts: {
                success: "משתמש נוצר בהצלחה! התחבר עכשיו!!!",
                fail: "שגיאה ביצירת המשתמש. בדוק את הנתונים שסופקו."
              },
              form: {
                name: "שם",
                email: "אימייל",
                password: "סיסמה"
              },
              buttons: {
                submit: "הרשם",
                login: "כבר יש לך חשבון? התחבר!"
              }
            },
            admin: {
              tag: "ניהול-על",
              exit: "חזרה לסביבת העבודה",
              enterSoftware: "כניסה לתוכנה",
              nav: {
                heading: "פלטפורמה",
                overview: "סקירה כללית",
                companies: "חברות",
                plans: "תוכניות",
                subscriptions: "מנויים",
                audit: "יומן ביקורת",
                compare: "השוואה",
                broadcasts: "שידורים",
                pages: "עמודים"
              },
              broadcast: {
                title: "שידורים",
                subtitle: "באנרי הכרזה לכל הלקוחות או ללקוח ספציפי",
                refresh: "רענן",
                compose: "שידור חדש",
                publish: "פרסם",
                publishing: "מפרסם…",
                cancel: "ביטול",
                empty: "אין שידורים עדיין. צור את הראשון למעלה.",
                loadError: "טעינת ההתראות נכשלה.",
                actionFailed: "הפעולה נכשלה",
                createFailed: "פרסום נכשל.",
                titleBodyRequired: "כותרת ותוכן נדרשים.",
                tenantTargetRequired: "בחר לקוח יעד לשידור ממוקד.",
                created: "השידור פורסם.",
                confirmDelete: "למחוק את \"{{title}}\"? לא ניתן לבטל.",
                endsOn: "עד {{date}}",
                col: {
                  title: "הודעה",
                  severity: "חומרה",
                  audience: "קהל",
                  created: "נוצר",
                  actions: "פעולות"
                },
                audience: {
                  all: "כל הלקוחות",
                  tenant: "לקוח ספציפי"
                },
                form: {
                  title: "כותרת",
                  body: "תוכן",
                  severity: "חומרה",
                  audience: "קהל",
                  target: "לקוח יעד",
                  endsAt: "פג בתאריך (לא חובה)"
                },
                tooltip: {
                  active: "פעיל (לחץ לעצירה)",
                  stopped: "מופסק (לחץ להפעלה)"
                },
                aria: {
                  active: "שידור פעיל",
                  stopped: "שידור מופסק"
                }
              },
              compare: {
                title: "השוואת לקוחות",
                subtitle: "נבחרו {{count}} מתוך {{max}} · מדדים תפעוליים זה לצד זה",
                add: "הוסף לקוח",
                remove: "הסר",
                searchPlaceholder: "חיפוש לפי שם חברה…",
                pickerEmpty: "אין חברות תואמות.",
                noPlan: "אין תוכנית",
                slotEmpty: "—",
                empty: {
                  title: "בחר לקוחות להשוואה",
                  sub: "הוסף עד 4 חברות — המדדים התפעוליים יוצגו זה לצד זה."
                },
                row: {
                  metric: "מדד",
                  status: "תקינות",
                  msgs24h: "הודעות 24ש",
                  tickets: "פניות פתוחות",
                  closed24h: "{{count}} נסגרו",
                  whatsapp: "WhatsApp",
                  users: "משתמשים",
                  queuesN: "{{count}} תורים",
                  ai: "מנוע AI",
                  spark: "נפח 7 ימים"
                }
              },
              audit: {
                title: "יומן ביקורת",
                subtitle: "כל פעולת מפעיל פלטפורמה על פני כל הלקוחות",
                refresh: "רענן",
                reset: "אפס",
                empty: "אין רשומות שתואמות לסינון.",
                filter: {
                  action: "פעולה",
                  allActions: "כל הפעולות",
                  admin: "מנהל",
                  allAdmins: "כל המנהלים",
                  since: "מ-",
                  until: "עד"
                },
                col: {
                  when: "מתי",
                  admin: "מנהל",
                  action: "פעולה",
                  target: "מטרה",
                  ip: "IP"
                },
                pagination: {
                  showing: "מציג {{start}}–{{end}} מתוך {{total}}",
                  prev: "הקודם",
                  next: "הבא"
                }
              },
              overview: {
                title: "סקירת חברות",
                subtitle: "מדדים ברמת הפלטפורמה על פני כל הלקוחות",
                loadError: "טעינת הסקירה נכשלה. נסה לרענן.",
                empty: "אין נתונים עדיין.",
                kpi: {
                  companies: "חברות",
                  active: "פעילות",
                  expiringSoon: "פגות בקרוב",
                  within7Days: "בתוך 7 ימים",
                  mrr: "MRR (משוער)",
                  mrrSub: "שווה-ערך חודשי",
                  newThisMonth: "+{{count}} החודש"
                },
                signups: {
                  title: "הצטרפויות (6 חודשים אחרונים)",
                  sub: "חברות חדשות בחודש"
                },
                plans: {
                  title: "פילוח תוכניות",
                  sub: "חלק יחסי של חברות בכל מסלול"
                },
                expiring: {
                  title: "פגות בקרוב",
                  viewAll: "ראה הכל",
                  empty: "אין פגיעות תוקף ב‑7 הימים הקרובים.",
                  today: "היום",
                  tomorrow: "מחר",
                  inDays: "בעוד {{days}} ימים"
                },
                attention: {
                  title: "דורש תשומת לב",
                  sub: "ספירה בלבד — פתח חברות לפעולה",
                  suspended: "מושעות",
                  pastDue: "תאריך פג",
                  aiOff: "AI כבוי",
                  openCompanies: "פתח חברות"
                },
                activity: {
                  title: "פעילות אחרונה בפלטפורמה",
                  viewAll: "פתח יומן ביקורת מלא",
                  empty: "עדיין לא נרשמו פעולות פלטפורמה.",
                  now: "כעת",
                  minAgo: "לפני {{count}} דק׳",
                  hAgo: "לפני {{count}} ש׳",
                  dAgo: "לפני {{count}} ימים"
                }
              },
              health: {
                backToCompanies: "חזרה לחברות",
                loadError: "טעינת נתוני הלקוח נכשלה.",
                actionFailed: "הפעולה נכשלה",
                justNow: "כעת",
                status: {
                  healthy: "תקין",
                  watch: "לעקוב",
                  critical: "קריטי"
                },
                reason: {
                  suspended: "מושעה",
                  no_whatsapp_session: "אין סשן WhatsApp",
                  whatsapp_disconnected: "WhatsApp מנותק",
                  no_activity_24h: "אין פעילות 24 שעות",
                  past_due: "עבר תאריך פג",
                  expiring_soon: "פג בקרוב"
                },
                kpi: {
                  msgs24h: "הודעות (24 שעות)",
                  totalLast24h: "נכנס + יוצא",
                  ticketsOpen: "פניות פתוחות",
                  closed24h: "{{count}} נסגרו ב‑24 שעות",
                  whatsapps: "WhatsApp",
                  connectedTotal: "מחוברים / סה״כ",
                  users: "משתמשים",
                  queues: "{{count}} תורים"
                },
                volume: {
                  title: "נפח הודעות (7 ימים אחרונים)",
                  sub: "סך יומי — רק מספרים"
                },
                config: {
                  title: "תצורה",
                  sub: "מטא-דאטה בלבד",
                  ai: "מנוע AI",
                  aiPromptSize: "גודל פרומפט AI",
                  chars: "תווים",
                  queues: "תורים",
                  settings: "שורות הגדרות",
                  dueDate: "תאריך פג",
                  on: "פעיל",
                  off: "כבוי"
                },
                activity: {
                  title: "פעולות אדמין אחרונות",
                  sub: "מפעילי פלטפורמה בלבד",
                  empty: "לא נרשמו פעולות פלטפורמה ללקוח זה.",
                  byUser: "ע״י אדמין #{{id}}"
                },
                action: {
                  impersonate: "התחברות בתור לקוח",
                  ai_enable: "AI הופעל",
                  ai_disable: "AI כובה",
                  suspend_tenant: "הושעה",
                  reactivate_tenant: "הופעל מחדש"
                },
                actions: {
                  enableAi: "הפעל AI",
                  disableAi: "כבה AI",
                  suspend: "השעה",
                  reactivate: "הפעל מחדש"
                },
                aiToggle: {
                  enabled: "AI הופעל",
                  disabled: "AI כובה"
                },
                confirm: {
                  suspend: "להשעות את {{name}}? לא יוכלו להתחבר.",
                  reactivate: "להפעיל מחדש את {{name}}?"
                },
                suspended: "הושעה",
                reactivated: "הופעל מחדש",
                toggleAiTip: "הפעלה/כיבוי של מנוע ה‑AI ללקוח זה"
              }
            },
            login: {
              title: "ברוכים השבים",
              subtitle: "התחבר/י כדי להמשיך לסביבת העבודה",
              form: {
                email: "אימייל",
                password: "סיסמה",
                remember: "זכור אותי",
                forgot: "שכחת סיסמה?"
              },
              buttons: {
                submit: "התחבר",
                register: "אין לך חשבון? הירשם!",
                haveAccount: "חדש כאן?"
              },
              brand: {
                meta: "וואטסאפ CRM",
                h1: "שיחות",
                h2a: "",
                h2b: "סוגרות",
                h3: "עסקאות.",
                subhead: "מערכת CRM מבוססת AI לוואטסאפ שעוזרת לכם לנהל, לבצע אוטומציה ולסגור יותר עסקאות — הכול במקום אחד.",
                f1: {
                  t: "כל השיחות במקום אחד",
                  b: "אף הודעה לא תפספס. הכול מסודר."
                },
                f2: {
                  t: "אוטומציה שחוסכת זמן",
                  b: "אוטומציה חכמה לתוצאות מהירות."
                },
                f3: {
                  t: "תובנות שמובילות לצמיחה",
                  b: "תדעו יותר, תחליטו טוב יותר, תסגרו יותר."
                }
              },
              secure: {
                title: "מאובטח ומוצפן",
                body: "המידע שלכם בטוח אצלנו"
              }
            },
            companies: {
              title: "הרשם לחברה",
              form: {
                name: "שם החברה",
                plan: "תוכנית",
                token: "אסימון",
                submit: "הרשם",
                success: "החברה נוצרה בהצלחה!"
              }
            },
            plansManager: {
              form: {
                name: "שם התוכנית",
                isPublic: "ציבורי",
                value: "מחיר",
                users: "משתמשים",
                connections: "חיבורים",
                queues: "תורים",
                options: {
                  yes: "כן",
                  no: "לא"
                },
                buttons: {
                  clear: "נקה",
                  delete: "מחק",
                  save: "שמור"
                }
              },
              table: {
                name: "שם",
                users: "משתמשים",
                isPublic: "ציבורי",
                connections: "חיבורים",
                queues: "תורים",
                value: "מחיר"
              },
              toasts: {
                loadError: "לא ניתן לטעון את רשימת התוכניות.",
                success: "הפעולה הושלמה בהצלחה!",
                saveError: "לא ניתן היה לבצע את הפעולה. בדקו אם קיימת כבר תוכנית עם אותו שם או אם השדות מולאו כראוי.",
                deleteError: "לא ניתן היה לבצע את הפעולה."
              },
              confirmation: {
                title: "אישור מחיקה",
                message: "האם אתה בטוח שברצונך למחוק את הרשומה הזו?"
              }
            },
            companiesManager: {
              form: {
                name: "שם",
                email: "אימייל",
                phone: "טלפון",
                plan: "תוכנית",
                status: "סטטוס",
                expiration: "תאריך תפוגה"
              },
              table: {
                name: "שם",
                email: "אימייל",
                phone: "טלפון",
                plan: "תוכנית",
                status: "סטטוס",
                createdAt: "נוצר ב",
                expiration: "תפוגה"
              }
            },
            auth: {
              toasts: {
                success: "ההתחברות הצליחה!"
              },
              token: "אסימון"
            },
            dashboard: {
              title: "לוח הבקרה של WhatsApp CRM",
              unassigned: "לא משויך",
              others: "אחרים",
              other: "אחר",
              status: {
                open: "פתוח",
                pending: "ממתין",
                closed: "סגור",
                unknown: "לא ידוע",
                online: "מחובר",
                offline: "לא מחובר"
              },
              charts: {
                perDay: {
                  title: "נוכחות היום: "
                },
                filters: {
                  button: "סנן",
                  startDate: "תאריך התחלה",
                  endDate: "תאריך סיום",
                  periodText: "תקופה",
                  periodOptions: {
                    input: "בחר את התקופה הרצויה",
                    zero: "לא נבחרה תקופה",
                    three: "השלושה האחרונים",
                    seven: "השבעה האחרונים",
                    fifteen: "החמישה עשר האחרונים",
                    thirty: "השלושים האחרונים",
                    sixty: "השישים האחרונים",
                    ninety: "התשעים האחרונים"
                  },
                  choosePeriod: "בחר את התקופה הרצויה",
                  selectError: "בחר לפחות אפשרות סינון אחת.",
                  quickRanges: {
                    day: "יום",
                    threeDays: "3 ימים",
                    week: "שבוע",
                    twoWeeks: "שבועיים",
                    month: "חודש",
                    threeMonths: "3 חודשים",
                    all: "כל הזמנים"
                  },
                  duedate: "תאריך יעד",
                  filtertype: {
                    title: "סוג הסנן",
                    valueA: "סינון לפי תאריך",
                    valueB: "סינון לפי תקופה",
                    helperText: "בחר את התקופה הרצויה"
                  }
                },
                noData: "אין נתונים להצגה",
                dayNames: {
                  full: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
                  short: ["יום א׳", "יום ב׳", "יום ג׳", "יום ד׳", "יום ה׳", "יום ו׳", "שבת"]
                },
                titles: {
                  tagsDistribution: "חלוקת כרטיסים לפי תגיות",
                  statusDistribution: "קריאות חדשות לפי סטטוס",
                  queueDistribution: "מספר כרטיסים לפי תור",
                  userDistribution: "מספר כרטיסים לפי משתמש",
                  dayDistribution: "כרטיסים לכל יום בשבוע",
                  messagesToday: "הודעות שהתקבלו היום",
                  newMessagesReceived: "הודעות חדשות שהתקבלו"
                }
              },
              cards: {
                attdPendants: "כרטיסי פתיחה ממתינים",
                attdHappening: "כרטיסי פתיחה פועלים",
                attdPerformed: "כרטיסי פתיחה סגורים",
                attdWaiting: "כרטיסי פתיחה ממתינים",
                leads: "הובלות",
                mtofService: "זמן שירות ממוצע",
                mtofwaiting: "זמן המתנה ממוצע",
                total: "סה\"כ כרטיסים"
              },
              campaigns: {
                title: "סיכום קמפיינים",
                total: "סה\"כ קמפיינים",
                sent: "הודעות נשלחו",
                delivered: "נמסרו",
                read: "נקראו",
                readRate: "אחוז קריאה",
                active: "פעילים",
                completed: "הושלמו",
                failed: "נכשלו"
              },
              gptAnalytics: {
                title: "ניתוח AI",
                refresh: "רענון ניתוח",
                refreshed: "הניתוח רוענן",
                error: "שגיאה בטעינת ניתוח",
                noData: "אין נתוני כרטיסים זמינים לניתוח",
                resolutionRate: "שיעור פתרון",
                avgResponseTime: "זמן תגובה ממוצע",
                activeTickets: "פעילים",
                waitingTickets: "ממתינים",
                overallSentiment: "ניתוח סנטימנט כללי",
                aiInsights: "תובנות AI",
                showMore: "הצג פרטים נוספים",
                showLess: "הצג פחות",
                topPerformer: "הביצועים הטובים ביותר",
                closed: "סגורים",
                queueDistribution: "התפלגות תורים",
                lastUpdated: "עודכן לאחרונה",
                insights: {
                  highResolution: "שיעור פתרון מצוין!",
                  lowResolution: "שיעור הפתרון דורש שיפור",
                  manyPending: "כרטיסים רבים ממתינים לתגובה",
                  ticketsClosed: "כרטיסים נסגרו",
                  slowResponse: "זמן התגובה מעל הממוצע",
                  fastResponse: "זמן תגובה מהיר!"
                }
              },
              table: {
                name: "שם",
                calif: "דירוגים",
                total: 'סה"כ',
                current: "כרטיסי פתיחה פעילים",
                closed: "כרטיסי פתיחה סגורים",
                timemedia: "זמן שירות ממוצע",
                waiting: "זמן המתנה ממוצע",
                statuschat: "סטטוס (נוכחי)",
                openCalls: "קריאות פתוחות",
                closedCalls: "קריאות סגורות",
                totalCalls: "סה״כ פניות",
                connected: "מחובר",
                disconnected: "לא מחובר",
                newCallsByDate: "קריאות חדשות לפי תאריך",
                status: "סטטוס",
                tickets: "פניות",
                avgHandle: "זמן טיפול ממוצע",
                rating: "דירוג",
                section: "טאב",
                avgHandleTime: "זמן טיפול ממוצע",
                closeRate: "אחוז סגירה",
                openCount: "פתוחים",
                avgWait: "זמן המתנה"
              },
              tooltip: {
                ticketsCount: "{{count}} כרטיסים"
              },
              ticketsByHour: {
                title: "מספר כרטיסים לפי שעה",
                formatButton: "פורמט: {{value}}",
                formatOptions: {
                  twelve: "12 שעות",
                  twentyFour: "24 שעות"
                },
                chartTypes: {
                  bar: "עמודות",
                  line: "קו",
                  area: "שטח"
                },
                legend: {
                  businessHours: "שעות עסקים (9:00-18:00)",
                  outOfHours: "מחוץ לשעות"
                },
                stats: {
                  title: "סטטיסטיקות לפי שעה",
                  peakHour: "שעת שיא",
                  peakHourCount: "{{count}} כרטיסים",
                  businessHours: "שעות עסקים",
                  businessHoursSuffix: "מסך כל הכרטיסים",
                  outOfHours: "מחוץ לשעות",
                  outOfHoursSuffix: "מסך כל הכרטיסים",
                  averagePerHour: "ממוצע לשעה",
                  averagePerHourSuffix: "כרטיסים לשעה"
                },
                seriesName: "כרטיסים"
              },
              subtitle: "הינה תמונת מצב חיה של הצוות שלך",
              greet: {
                morning: "בוקר טוב",
                afternoon: "צהריים טובים",
                evening: "ערב טוב",
                night: "לילה טוב"
              },
              range: {
                today: "היום",
                yesterday: "אתמול",
                "7d": "7 ימים",
                "30d": "30 ימים",
                "90d": "90 ימים",
                custom: "מותאם אישית"
              },
              trend: {
                vsPrev: "מהתקופה הקודמת"
              },
              role: {
                admin: "מנהל",
                supervisor: "מפקח",
                agent: "נציג"
              },
              filter: {
                label: "פילטרים",
                title: "סינון נתונים",
                queue: "תור",
                whatsapp: "חשבון WhatsApp",
                agent: "נציג",
                all: "הכל",
                clear: "נקה פילטרים",
                from: "מ-",
                to: "עד"
              },
              breadcrumb: {
                home: "בית",
                dashboard: "לוח בקרה"
              },
              pulse: {
                systemStable: "המערכת יציבה",
                activeChats: "שיחות פעילות",
                onlineAgents: "נציגים מחוברים",
                activeNow: "שיחות פעילות כרגע"
              },
              kpi: {
                newMessages: "הודעות חדשות",
                open: "פתוחים",
                pending: "ממתינים",
                inProgress: "בטיפול",
                closed: "נסגרו",
                newCustomers: "לקוחות חדשים",
                totalTickets: 'סה"כ פניות',
                uniqueCustomers: "לקוחות ייחודיים",
                messagesReceived: "הודעות שהתקבלו"
              },
              panel: {
                messagesToday: "הודעות שהתקבלו היום",
                messagesRange: "הודעות ב-{{periodLabel}}",
                ticketsByStatus: "חלוקת כרטיסים לפי סטטוס",
                ticketsByHour: "כרטיסים לפי שעה",
                generalStats: "סטטיסטיקות כלליות",
                agents: "נציגי שירות",
                sections: "כרטיסים לפי טאב מותאם",
                sectionsSub: "פילוח כרטיסים לפי הטאבים המותאמים אישית",
                inPeriod: "בתקופה הנבחרת"
              },
              donut: {
                total: 'סה"כ כרטיסים'
              },
              metric: {
                avgHandle: "זמן טיפול ממוצע",
                avgWait: "זמן מענה ממוצע",
                totalTickets: 'סה"כ פניות',
                uniqueTickets: "פניות ייחודיות",
                messagesSent: "הודעות שנשלחו"
              },
              agents: {
                empty: "אין נתוני נציגים להצגה"
              },
              unit: {
                messages: "הודעות",
                tickets: "כרטיסים"
              }
            },
            connections: {
              title: "חיבורים",
              connected: "מחובר",
              hub: {
                statusBadge: {
                  connected: "מחובר",
                  pending: "מתחבר",
                  disconnected: "לא מחובר",
                  loading: "טוען..."
                },
                instagramNative: {
                  title: "Instagram",
                  description: "חברו את חשבון האינסטגרם ישירות — ללא צורך בעמוד פייסבוק.",
                  connect: "התחבר לאינסטגרם",
                  reconnect: "התחבר מחדש",
                  disconnect: "נתק",
                  connected: "אינסטגרם חובר בהצלחה!",
                  connectedSub: "מחובר ישירות",
                  idleSub: "התחברות עם Instagram Business Login",
                  expiredSub: "ההתחברות פגה — התחבר מחדש"
                }
              },
              toasts: {
                deleted: "חיבור WhatsApp נמחק בהצלחה!"
              },
              confirmationModal: {
                deleteTitle: "מחק",
                deleteMessage: "האם אתה בטוח? פעולה זו אינה ניתנת לביטול.",
                disconnectTitle: "נתק",
                disconnectMessage: "האם אתה בטוח? תצטרך לסרוק מחדש את קוד ה-QR."
              },
              buttons: {
                add: "הוסף WhatsApp",
                disconnect: "נתק",
                tryAgain: "נסה שוב",
                qrcode: "קוד QR",
                newQr: "קוד QR חדש",
                connecting: "מתחבר"
              },
              toolTips: {
                disconnected: {
                  title: "נכשל להתחיל סשן WhatsApp",
                  content: "ודא שהטלפון שלך מחובר לאינטרנט ונסה שוב, או בקש קוד QR חדש."
                },
                qrcode: {
                  title: "ממתין לסריקת קוד QR",
                  content: "לחץ על הכפתור 'קוד QR' וסרוק את קוד ה-QR בטלפון שלך כדי להתחיל את הסשן."
                },
                connected: {
                  title: "חיבור הוקמה!"
                },
                timeout: {
                  title: "החיבור לטלפון אבד",
                  content: "ודא שהטלפון שלך מחובר לאינטרנט וש-WhatsApp פתוח, או לחץ על 'נתק' כדי לקבל קוד QR חדש."
                }
              },
              table: {
                name: "שם",
                status: "סטטוס",
                lastUpdate: "עדכון אחרון",
                default: "ברירת מחדל",
                actions: "פעולות",
                session: "סשן"
              }
            },
            tasks: {
              new: "משימה חדשה",
              add: "הוסף",
              save: "שמור"
            },
            rankings: {
              title: "דירוג סוכנים",
              topSeller: "🔥 המוביל של החודש:",
              table: "סך הכל",
              topPerformer: "ביצועים מובילים",
              period: "תקופה",
              totalSales: "סה״כ מכירות",
              rank: "#",
              name: "שם",
              sales: "סך הכל במכירות",
              actions: "פעולות",
              eyebrow: "צוות",
              salesLabel: "מכירות",
              stats: {
                agents: "סוכנים"
              },
              empty: {
                title: "עדיין לא נרשמו מכירות",
                adminHelp: "מכירות הוא מונה ידני — פתח משתמשים וערוך כל סוכן כדי לעדכן את סך המכירות שלו.",
                userHelp: "ברגע שמנהל המערכת ירשום מכירות לצוות, הדירוג יופיע כאן.",
                editUsersBtn: "פתח משתמשים"
              }
            },
            appointments: {
              title: "יומן פגישות",
              eyebrow: "תזמון",
              heroSubtitleAdmin: "נהל את אופן ההזמנה של הבוט בוואטסאפ ואת מה שמגיע ליומן שלך.",
              heroSubtitleOperator: "צפה בהזמנות שהבוט בוואטסאפ יצר.",
              common: {
                cancel: "ביטול",
                back: "חזרה"
              },
              when: {
                today: "היום",
                tomorrow: "מחר"
              },
              summary: {
                allWeek: "כל השבוע"
              },
              connect: {
                title: "חיבור יומן",
                subtitle: "הבוט הבינה המלאכותית קורא חלונות פנויים מהיומן המחובר ויוצר אירועים כשלקוחות מזמינים דרך וואטסאפ.",
                notConnectedTag: "לא חובר יומן",
                googleBtn: "חבר Google Calendar",
                microsoftBtn: "חבר Outlook",
                statusConnected: "מחובר",
                lastSynced: "סנכרון אחרון",
                disconnectBtn: "ניתוק",
                confirmDisconnectTitle: "לנתק יומן?",
                confirmDisconnectBody: "הבוט יפסיק להציע חלונות וליצור אירועים עד שיחובר יומן מחדש. ההזמנות הקיימות נשמרות.",
                disconnectedToast: "היומן נותק"
              },
              workingHours: {
                eyebrow: "הגדרות",
                title: "שעות פעילות",
                subtitle: "ימים ושעות שבהם הבוט רשאי להציע חלונות.",
                daysLabel: "ימים שהבוט יכול להציע",
                days: {
                  0: "א'",
                  1: "ב'",
                  2: "ג'",
                  3: "ד'",
                  4: "ה'",
                  5: "ו'",
                  6: "ש'"
                },
                startLabel: "התחלה",
                endLabel: "סיום",
                saveBtn: "שמור הגדרות",
                savingBtn: "שומר...",
                savedToast: "ההגדרות נשמרו"
              },
              slotConfig: {
                durationLabel: "משך פגישה",
                bufferLabel: "מרווח בין פגישות"
              },
              bookings: {
                eyebrow: "פעילות",
                title: "הזמנות",
                upcomingLabel: "עתידיות",
                totalLabel: "סה\"כ",
                emptyTitle: "אין הזמנות עדיין",
                emptyBody: "הן יופיעו כאן אוטומטית ברגע שלקוח יזמין דרך הבוט בוואטסאפ.",
                cols: {
                  customer: "לקוח",
                  phone: "טלפון",
                  scheduledAt: "מועד",
                  status: "סטטוס",
                  type: "סוג",
                  location: "מיקום",
                  actions: ""
                },
                statuses: {
                  pending: "ממתין",
                  confirmed: "אושר",
                  reminderSent: "תזכורת נשלחה",
                  completed: "הושלם",
                  cancelled: "בוטל"
                },
                cancelBtn: "ביטול הזמנה",
                confirmCancelTitle: "לבטל את ההזמנה?",
                confirmCancelBody: "האירוע ביומן יוסר והלקוח יקבל הודעה על הביטול.",
                confirmCancelBtn: "בטל הזמנה",
                cancelledToast: "ההזמנה בוטלה"
              },
              errors: {
                connectFailed: "לא ניתן לפתוח את מסך ההסכמה של ספק היומן."
              },
              botConfig: {
                eyebrow: "בוט ותזכורות",
                title: "בוט תזמון ותזכורות",
                subtitle: "כיצד הבוט עונה בוואטסאפ ומתי נשלחות תזכורות.",
                botEnabledLabel: "בוט תזמון AI",
                botEnabledOn: "פעיל",
                botEnabledOff: "כבוי",
                languageLabel: "שפת תגובות הבוט",
                reminderLeadLabel: "זמן הקדמת תזכורת",
                confirmationTimeoutLabel: "תפוגת אישור",
                templateNameLabel: "שם תבנית וואטסאפ",
                templateNameHelp: "חייב להתאים לתבנית מאושרת במטא (לדוגמה whapiz_appointment_reminder).",
                signatureLabel: "חתימה עסקית",
                saveBtn: "שמור הגדרות בוט",
                savingBtn: "שומר...",
                savedToast: "הגדרות הבוט נשמרו",
                errors: {
                  templateNameRequired: "שם תבנית הוא שדה חובה — תזכורות לא ייצאו בלעדיו."
                }
              },
              oauth: {
                successTitle: "היומן חובר",
                successBody: "הכול מוכן",
                providerGoogle: "Google Calendar",
                providerMicrosoft: "Microsoft Outlook",
                errorTitle: "החיבור נכשל",
                errorBody: "נסה שוב"
              }
            },
            internalChat: {
              title: "צ'אט פנימי",
              conversations: "שיחות",
              newChat: "צ'אט חדש",
              editChat: "עריכת צ'אט",
              chatTitle: "כותרת הצ'אט",
              chatTitlePlaceholder: "הזן כותרת לצ'אט...",
              passwordOptional: "סיסמה (אופציונלי)",
              passwordPlaceholder: "הגדר סיסמה להגנה על הצ'אט",
              selectParticipants: "בחר משתתפים",
              cancel: "ביטול",
              create: "צור",
              save: "שמור",
              confirm: "אישור",
              delete: "מחק",
              deleteChat: "מחק צ'אט",
              confirmDelete: "האם אתה בטוח שברצונך למחוק את הצ'אט הזה?",
              chatCreated: "הצ'אט נוצר בהצלחה",
              chatUpdated: "הצ'אט עודכן בהצלחה",
              chatDeleted: "הצ'אט נמחק בהצלחה",
              error: "אירעה שגיאה",
              titleRequired: "אנא הזן כותרת לצ'אט",
              usersRequired: "אנא בחר לפחות משתתף אחד",
              selectChat: "בחר שיחה",
              selectChatDesc: "בחר צ'אט מהרשימה כדי להתחיל לשלוח הודעות",
              emptyActions: {
                newChat: "צ'אט חדש",
                conversations: "שיחות",
                messages: "הודעות"
              },
              noChats: "אין שיחות עדיין",
              noMessages: "אין הודעות",
              startConversation: "התחל שיחה",
              placeholder: "הקלד הודעה...",
              download: "הורד",
              yesterday: "אתמול",
              owner: "בעלים",
              participants: "משתתפים",
              showOwner: "הצג בעלים",
              showUsers: "הצג משתתפים",
              passwordRequired: "נדרשת סיסמה",
              password: "סיסמה",
              incorrectPassword: "סיסמה שגויה",
              passwordError: "שגיאה באימות הסיסמה",
              chats: "צ'אטים",
              messages: "הודעות",
              noChat: "לא נבחר צ'אט",
              addMember: "הוסף משתתף",
              add: "הוסף",
              memberAdded: "משתתף נוסף בהצלחה!",
              close: "סגור",
              saving: "מוסיף...",
              changeColor: "שנה צבע שיחה",
              eyebrow: "צוות",
              stats: {
                conversations: "שיחות"
              },
              dialog: {
                text: "כותרת",
                title: "שיחה",
                buttons: {
                  cancel: "ביטול",
                  save: "שמור"
                }
              }
            },
            whatsappModal: {
              title: {
                add: "הוסף WhatsApp",
                edit: "ערוך WhatsApp"
              },
              form: {
                name: "שם",
                default: "ברירת מחדל",
                channel: "ערוץ",
                channelDescription: "בחרו אם החיבור יעבוד דרך Baileys (סריקת QR) או דרך ה-API הרשמי של Meta.",
                token: "אסימון גישה של Meta",
                tokenDescription: "הדביקו כאן את אסימון המשתמש (System User) הקבוע שסופק על ידי Meta.",
                defaultDisabled: "ניתן להגדיר ברירת מחדל רק בחיבורי Baileys.",
                channelLabelTitle: "תווית ערוץ",
                channelLabelDescription: "הוסף תווית לזיהוי מספר זה בצ'אטים (לדוגמה: אתר, ראשי, תמיכה)",
                channelLabel: "תווית",
                channelLabelColor: "צבע"
              },
              channelOptions: {
                whatsapp: "WhatsApp Web (Baileys)",
                business: "Meta Business API"
              },
              buttons: {
                okAdd: "הוסף",
                okEdit: "שמור",
                cancel: "ביטול"
              },
              success: "WhatsApp נשמר בהצלחה."
            },
            qrCode: {
              message: "סרוק את קוד ה-QR כדי להתחיל את הסשן"
            },
            contacts: {
              title: "אנשי קשר",
              whatsappUser: "משתמש וואטסאפ",
              toasts: {
                deleted: "איש קשר נמחק בהצלחה!",
                imported: "אנשי הקשר יובאו בהצלחה!"
              },
              searchPlaceholder: "חיפוש...",
              confirmationModal: {
                deleteTitle: "מחק",
                importTitlte: "ייבא אנשי קשר",
                deleteMessage: "האם אתה בטוח שברצונך למחוק את איש הקשר הזה? כל האינטראקציות הקשורות יאבדו.",
                importMessage: "האם ברצונך לייבא את כל אנשי הקשר מהטלפון?"
              },
              buttons: {
                import: "ייבא אנשי קשר",
                add: "הוסף איש קשר",
                export: "ייצוא אנשי קשר",
                delete: "מחק את כל אנשי הקשר"
              },
              table: {
                name: "שם",
                whatsapp: "WhatsApp",
                email: "אימייל",
                actions: "פעולות",
                phone: "טלפון"
              }
            },
            contactModal: {
              title: {
                add: "הוסף איש קשר",
                edit: "ערוך איש קשר"
              },
              form: {
                mainInfo: "מידע על איש הקשר",
                extraInfo: "מידע נוסף",
                name: "שם",
                number: "מספר WhatsApp",
                email: "אימייל",
                extraName: "שם השדה",
                extraValue: "ערך",
                disableBot: "השבת צ'אטבוט"
              },
              buttons: {
                addExtraInfo: "הוסף מידע",
                okAdd: "הוסף",
                okEdit: "שמור",
                cancel: "ביטול"
              },
              noOption: "אין אפשרות, הוסף חדש",
              success: "איש הקשר נשמר בהצלחה."
            },
            forwardMessageModal: {
              dialog: {
                title: "העברה של הודעה זו אל:",
                button: "שלח כעת",
                sending: "שולח",
                error: "יש לבחור הודעות להעברה"
              }
            },
            templates: {
              title: "תבניות WhatsApp",
              syncButton: "סנכרון מ-Meta",
              syncFromMeta: "סנכרון מ-Meta",
              sync: "סנכרון",
              syncing: "מסנכרן...",
              noTemplates: "לא נמצאו תבניות. לחץ על 'סנכרון מ-Meta' לייבוא תבניות.",
              syncNow: "סנכרן תבניות עכשיו",
              preview: "תצוגה מקדימה",
              fillVariables: "מלא משתנים",
              lastSynced: "סונכרן לאחרונה",
              description: "תבניות הן הודעות מאושרות מראש שניתן לשלוח ללקוחות לאחר חלון הזמן של 24 שעות. צור תבניות ב-Meta Business Manager, ואז לחץ על 'סנכרון מ-Meta' לייבוא.",
              connections: "חיבורי WhatsApp Business",
              errors: {
                fillAllVariables: "אנא מלא את כל המשתנים",
                sendFailed: "שליחת התבנית נכשלה",
                syncFailed: "סנכרון התבניות נכשל"
              },
              success: {
                sent: "התבנית נשלחה בהצלחה",
                synced: "התבניות סונכרנו בהצלחה"
              },
              buttons: {
                send: "שלח תבנית",
                cancel: "ביטול"
              },
              table: {
                name: "שם",
                language: "שפה",
                connection: "חיבור",
                status: "סטטוס",
                category: "קטגוריה",
                active: "פעיל",
                preview: "תצוגה מקדימה"
              },
              categories: {
                utility: "שירות",
                marketing: "שיווק",
                authentication: "אימות"
              },
              active: "פעיל",
              inactive: "לא פעיל",
              refresh: "רענון",
              stats: {
                total: "סה״כ",
                approved: "אושרו",
                pending: "ממתינות",
                rejected: "נדחו"
              }
            },
            gptMenu: {
              aiSuggestions: "הצעות AI",
              conversationSummary: "סיכום שיחה",
              salesOpportunities: "הזדמנויות מכירה",
              sentimentAnalysis: "ניתוח סנטימנט",
              agentPerformance: "ביצועי נציג",
              keyIssues: "בעיות מרכזיות"
            },
            gptSettings: {
              title: "עוזר GPT AI",
              subtitle: "הצעות מבוססות AI לצוות התמיכה שלך",
              enableTitle: "הפעל עוזר GPT",
              enableDescription: "הצעות AI יופיעו בשיחות טיקטים",
              status: "סטטוס",
              apiKeyConfigured: "מפתח API מוגדר",
              apiKeyMissing: "מפתח API חסר",
              gptEnabled: "GPT מופעל",
              gptDisabled: "GPT מושבת",
              currentModel: "מודל נוכחי",
              apiConfiguration: "הגדרת API",
              aiModel: "מודל AI",
              openaiApiKey: "מפתח OpenAI API",
              getApiKey: "קבל את מפתח ה-API שלך מ-platform.openai.com",
              recommended: "מומלץ",
              responseTone: "טון תגובה",
              responseToneDescription: "בחר כיצד ה-AI יתקשר",
              advancedSettings: "הגדרות מתקדמות",
              customPrompt: "פרומפט מערכת מותאם",
              customPromptPlaceholder: "הוסף הוראות מותאמות ל-AI...",
              customPromptHint: "זה יתווסף לכל תגובות ה-AI",
              saveSettings: "שמור הגדרות",
              saving: "שומר...",
              saved: "ההגדרות נשמרו.",
              loading: "טוען...",
              showAdvanced: "הצג מתקדם",
              hideAdvanced: "הסתר מתקדם",
              statusDesc: "מצב חיבור עוזר ה-AI",
              apiConfigDesc: "מפתח OpenAI ומודל",
              advancedDesc: "פרומפט מערכת מותאם"
            },
            gptModals: {
              noTicketSelected: "לא נבחר כרטיס",
              errorLoadingPerformance: "שגיאה בטעינת ביצועי סוכן"
            },
            contactNotesDialog: {
              deleteTitle: "מחיקת רשומה"
            },
            aiDashboard: {
              title: "לוח בקרה AI",
              refresh: "רענן",
              noData: "אין נתונים זמינים",
              noDataForPeriod: "אין נתונים זמינים לתקופה זו",
              allAgents: "כל הנציגים",
              daysCount: "{{count}} ימים",
              singleDay: "יום",
              multiDay: "ימים",
              kpi: {
                totalConversations: 'סה"כ שיחות',
                open: "פתוחים",
                pending: "ממתינים",
                closed: "סגורים",
                responseTime: "זמן מענה",
                satisfaction: "שביעות רצון",
                resolvedPct: "{{pct}}% פתורים",
                outOfFive: "מתוך 5.0"
              },
              subtitle: {
                chats: "{{count}} שיחות",
                activeAgents: "{{count}} נציגים פעילים"
              },
              quickInsights: {
                loadSubtitle: "{{score}}/100 עומס",
                resolutionSubtitle: "{{closed}} מתוך {{total}}",
                avgPerTicket: "ממוצע לפניה",
                noStats: "אין נתונים",
                customerSatisfaction: "שביעות רצון לקוחות"
              },
              units: {
                minuteAbbr: "דק'",
                hourAbbr: "שע'",
                dayAbbr: "ימ'"
              },
              tabs: {
                overview: "סקירה כללית",
                agentPerformance: "ביצועי סוכנים",
                keyIssues: "בעיות עיקריות",
                sentimentTrends: "מגמות סנטימנט",
                salesInsights: "תובנות מכירות",
                learning: "למידה"
              },
              filters: {
                dateRange: "טווח תאריכים",
                last7days: "7 ימים אחרונים",
                last14days: "14 ימים אחרונים",
                last30days: "30 ימים אחרונים",
                last90days: "90 ימים אחרונים"
              },
              overview: {
                totalConversations: "סה\"כ שיחות",
                avgResponseTime: "זמן תגובה ממוצע",
                resolutionRate: "שיעור פתרון",
                satisfaction: "שביעות רצון לקוחות",
                aiPerformance: "ביצועי AI",
                suggestionsUsed: "הצעות AI שהשתמשו",
                aiAccuracy: "דיוק AI",
                activeAgents: "סוכנים פעילים",
                pendingTickets: "טיקטים ממתינים",
                quickInsights: "תובנות מהירות",
                workload: "עומס עבודה",
                openTickets: "טיקטים פתוחים",
                ticketsPerAgent: "טיקטים לסוכן",
                workloadLevel: "רמת עומס",
                systemStatus: "סטטוס מערכת",
                closedToday: "נסגרו היום"
              },
              status: {
                normal: "תקין",
                moderate: "עומס בינוני",
                highLoad: "עומס גבוה"
              },
              insights: {
                peakHours: "שעות שיא פעילות",
                peakHoursDesc: "רוב השיחות מתרחשות בין 10:00-14:00",
                topPerformer: "מצטיין",
                topPerformerDesc: "על סמך זמן תגובה ושיעור פתרון"
              },
              agentPerformance: {
                selectAgent: "בחר סוכן",
                allAgents: "כל הסוכנים",
                responseTime: "זמן תגובה ממוצע",
                ticketsHandled: "טיקטים שטופלו",
                qualityScore: "ציון איכות",
                detailedAnalysis: "ניתוח מפורט",
                workload: "עומס עבודה",
                politenessScore: "ציון נימוס",
                aiRecommendations: "המלצות AI",
                firstResponse: "תגובה ראשונה",
                missedMessages: "הודעות שהוחמצו",
                ticketsResolved: "טיקטים שנפתרו",
                sentimentTrend: "מגמת סנטימנט",
                confusionCases: "מקרי בלבול",
                recoveryRate: "שיעור התאוששות",
                resolutionRate: "שיעור פתרון",
                improving: "משתפר",
                declining: "יורד",
                stable: "יציב"
              },
              keyIssues: {
                title: "בעיות שזוהו",
                subtitle: "בעיות שזוהו בשיחות לקוחות",
                occurrences: "מופעים",
                lastSeen: "נראה לאחרונה",
                noIssues: "לא זוהו בעיות קריטיות",
                unknownIssue: "בעיה לא ידועה",
                ticketsAffected: "טיקטים מושפעים",
                patterns: "דפוסים נפוצים",
                recommendations: "המלצות"
              },
              sentiment: {
                positive: "חיובי",
                neutral: "נייטרלי",
                negative: "שלילי",
                trends: "מגמות סנטימנט",
                trendsDescription: "עקוב אחר סנטימנט לקוחות לאורך זמן לזיהוי דפוסים ושיפורים",
                trend: "מגמה",
                messagesAnalyzed: "הודעות שנותחו",
                topPositiveKeywords: "מילות מפתח חיוביות",
                topNegativeKeywords: "מילות מפתח שליליות",
                improving: "משתפר",
                declining: "יורד",
                stable: "יציב"
              },
              salesInsights: {
                title: "הזדמנויות מכירה",
                upsellOpportunities: "הזדמנויות לשדרוג",
                upsellDescription: "שיחות עם פוטנציאל למכירות נוספות",
                conversionRate: "שיעור המרה",
                conversionDescription: "לידים שהומרו להזמנות מוצלחות",
                totalOpportunities: "סה\"כ הזדמנויות",
                revenuePotential: "פוטנציאל הכנסות",
                upsellCrossSell: "שדרוג + מכירה צולבת",
                opportunitiesByType: "הזדמנויות לפי סוג",
                upsell: "שדרוג",
                crossSell: "מכירה צולבת",
                newProduct: "מוצר חדש",
                topProductsMentioned: "מוצרים נפוצים",
                noProductsDetected: "לא זוהו מוצרים",
                recentOpportunities: "הזדמנויות אחרונות"
              }
            },
            aiWorkforce: {
              title: "צוות AI",
              refresh: "רענון",
              enabled: "פעיל",
              disabled: "מושבת",
              stats: {
                activeAgents: "סוכנים פעילים",
                knowledgeItems: "פריטי ידע",
                businessRules: "כללים עסקיים",
                actionsToday: "פעולות היום"
              },
              tabs: {
                agents: "סוכני AI",
                knowledge: "בסיס ידע",
                rules: "כללים עסקיים",
                logs: "יומן פעולות",
                pipeline: "צינור עיבוד"
              },
              pipeline: {
                enableCustom: "הפעל צינור AI מותאם אישית",
                enableDesc: "כאשר מופעל, החברה משתמשת בצינור AI מותאם אישית במקום ברירת המחדל.",
                dataSource: "מקור נתונים",
                dataSourceType: "סוג",
                dataSourceNone: "ללא",
                testConnection: "בדוק חיבור",
                connected: "מחובר",
                connectionFailed: "החיבור נכשל",
                pipelineSteps: "שלבי צינור",
                pipelineStepsDesc: "הגדר את סדר שלבי עיבוד ה-AI. כל שלב מעשיר את ההקשר לשלב הבא.",
                aiTools: "כלי AI",
                addTool: "הוסף כלי",
                aiToolsDesc: "הגדר אילו נתונים ה-AI יכול לשלוף ממקור הנתונים שלך.",
                noTools: "לא הוגדרו כלים. הוסף כלי כדי לאפשר שאילתות נתונים ל-AI.",
                table: "טבלה",
                filter: "סינון",
                fields: "שדות",
                systemPrompt: "הנחיית מערכת",
                systemPromptPlaceholder: "תאר את העסק שלך וכיצד ה-AI צריך לעזור ללקוחות. לדוגמה: 'אתה עוזר וירטואלי של חברת ניהול מבנים. עזור לדיירים עם בירור תשלומים, בקשות תחזוקה ושאלות כלליות.'",
                saving: "שומר...",
                saveSettings: "שמור הגדרות צינור",
                saved: "הגדרות הצינור נשמרו",
                steps: {
                  dataFetcher: "שליפת נתונים",
                  dataFetcherDesc: "שאילתה ממקור נתונים חיצוני",
                  conversation: "שיחה",
                  conversationDesc: "יצירת תגובת AI",
                  supervisor: "מפקח",
                  supervisorDesc: "בדיקת איכות לפני שליחה"
                },
                toolDialog: {
                  addTitle: "הוספת כלי",
                  editTitle: "עריכת כלי",
                  toolName: "שם הכלי",
                  description: "תיאור",
                  tableEndpoint: "טבלה / נקודת קצה",
                  filterField: "שדה סינון (אופציונלי)",
                  fieldsComma: "שדות (מופרדים בפסיק, אופציונלי)",
                  cancel: "ביטול",
                  add: "הוספה",
                  update: "עדכון"
                }
              },
              agents: {
                title: "הגדרות סוכני AI",
                addAgent: "הוסף סוכן",
                createTitle: "יצירת סוכן",
                editTitle: "עריכת סוכן",
                name: "שם הסוכן",
                role: "תפקיד",
                model: "מודל GPT",
                temperature: "טמפרטורה",
                maxTokens: "מקסימום טוקנים",
                systemPrompt: "הנחיית מערכת (אופציונלי)",
                agentEnabled: "סוכן מופעל",
                test: "בדיקה",
                testAgent: "בדיקת סוכן",
                runningTest: "מריץ בדיקה...",
                testSuccess: "הבדיקה הושלמה בהצלחה",
                result: "תוצאה",
                noAgents: "אין סוכני AI עדיין",
                noAgentsDesc: "צור את סוכן ה-AI הראשון שלך לאוטומציה של תהליכים",
                deleteConfirm: "האם אתה בטוח שברצונך למחוק סוכן זה?",
                created: "הסוכן נוצר בהצלחה",
                updated: "הסוכן עודכן בהצלחה",
                deleted: "הסוכן נמחק",
                roles: {
                  conversation: "סוכן שיחה",
                  queue_manager: "מנהל תורים",
                  process_finisher: "מסיים תהליכים",
                  offer_matcher: "התאמת הצעות",
                  pricing_calculator: "מחשבון מחירים",
                  promotion_engine: "מנוע מבצעים",
                  supervisor: "סוכן מפקח",
                  business_intelligence: "בינה עסקית",
                  scheduling_manager: "מנהל לוח זמנים",
                  notification_engine: "מנוע התראות"
                },
                models: {
                  gpt4o: "GPT-4o (מומלץ)",
                  gpt4turbo: "GPT-4 Turbo",
                  gpt35turbo: "GPT-3.5 Turbo (מהיר יותר)"
                },
                temperatureLabels: {
                  precise: "מדויק",
                  creative: "יצירתי"
                }
              },
              knowledge: {
                title: "בסיס ידע",
                add: "הוסף",
                createTitle: "הוספת ידע",
                editTitle: "עריכת ידע",
                titleField: "כותרת",
                content: "תוכן",
                type: "סוג",
                active: "פעיל",
                inactive: "לא פעיל",
                updated: "עודכן",
                search: "חיפוש...",
                noKnowledge: "אין רשומות ידע",
                noKnowledgeDesc: "הוסף מוצרים, שאלות נפוצות ומדיניות לשימוש ה-AI",
                deleteConfirm: "למחוק רשומת ידע זו?",
                created: "הידע נוצר",
                updatedMsg: "הידע עודכן",
                deleted: "הידע נמחק",
                types: {
                  product: "מוצר",
                  faq: "שאלות נפוצות",
                  policy: "מדיניות",
                  general: "כללי",
                  supplier: "ספק",
                  destination: "יעד"
                }
              },
              rules: {
                title: "כללים עסקיים",
                addRule: "הוסף כלל",
                createTitle: "הוספת כלל",
                editTitle: "עריכת כלל",
                name: "שם הכלל",
                type: "סוג",
                description: "תיאור",
                priority: "עדיפות",
                conditions: "תנאים (JSON)",
                actions: "פעולות (JSON)",
                active: "פעיל",
                inactive: "לא פעיל",
                noRules: "אין כללים עסקיים",
                noRulesDesc: "הגדר כללי תמחור, ניתוב והסלמה",
                deleteConfirm: "למחוק כלל זה?",
                created: "הכלל נוצר",
                updated: "הכלל עודכן",
                deleted: "הכלל נמחק",
                types: {
                  pricing: "תמחור",
                  promotion: "מבצע",
                  routing: "ניתוב",
                  escalation: "הסלמה",
                  commission: "עמלה",
                  general: "כללי"
                },
                keywordsHelper: "לדוגמה: ביטול, עצור, מנהל"
              },
              logs: {
                title: "יומן פעולות AI",
                noLogs: "אין יומנים עדיין",
                noLogsDesc: "פעולות AI יופיעו כאן",
                ticket: "כרטיס"
              },
              common: {
                save: "שמור",
                cancel: "ביטול",
                close: "סגור",
                all: "הכל",
                name: "שם",
                status: "סטטוס",
                actions: "פעולות",
                edit: "עריכה",
                delete: "מחיקה"
              }
            },
            offers: {
              title: "קטלוג הצעות",
              newOffer: "הצעה חדשה",
              searchPlaceholder: "חיפוש הצעות...",
              stats: {
                total: "סה״כ הצעות",
                active: "פעילות",
                featured: "מובילות"
              },
              source: {
                label: "מקור",
                all: "כל המקורות",
                internal: "פנימי",
                external: "Raviv API",
                offerDetails: "פרטי הצעה"
              },
              table: {
                offer: "הצעה",
                destination: "יעד",
                duration: "משך",
                price: "מחיר",
                status: "סטטוס",
                featured: "מובילה",
                actions: "פעולות",
                nights: "לילות",
                active: "פעיל",
                inactive: "לא פעיל"
              },
              modal: {
                createTitle: "יצירת הצעה חדשה",
                editTitle: "עריכת הצעה",
                sections: {
                  basicInfo: "מידע בסיסי",
                  destination: "יעד",
                  datesDuration: "תאריכים ומשך",
                  pricing: "מחירים",
                  accommodation: "לינה",
                  flight: "טיסה (אופציונלי)",
                  images: "תמונות",
                  status: "סטטוס"
                },
                fields: {
                  title: "כותרת",
                  titlePlaceholder: "למשל, חופשה רומנטית בפריז",
                  type: "סוג",
                  description: "תיאור",
                  descriptionPlaceholder: "תאר מה הופך את ההצעה הזו למיוחדת...",
                  destination: "יעד",
                  destinationPlaceholder: "למשל, פריז",
                  country: "מדינה",
                  countryPlaceholder: "למשל, צרפת",
                  validFrom: "בתוקף מ",
                  validTo: "בתוקף עד",
                  days: "ימים",
                  nights: "לילות",
                  basePrice: "מחיר בסיס",
                  currency: "מטבע",
                  childPrice: "מחיר ילד",
                  markup: "% תוספת",
                  hotelName: "שם המלון",
                  stars: "כוכבים",
                  board: "אירוח",
                  airline: "חברת תעופה",
                  departureCity: "עיר המראה",
                  compositionPricing: "תמחור לפי הרכב משפחתי (סה\"כ לקבוצה)",
                  compositionPricingHint: "הגדר מחירים כוללים לכל הרכב משפחתי. השאר ריק לחישוב אוטומטי לפי מחיר בסיס × מספר נוסעים.",
                  pricingCouple: "זוג",
                  pricingCouple1Child: "זוג + ילד 1",
                  pricingCouple2Children: "זוג + 2 ילדים",
                  pricingCouple3Children: "זוג + 3 ילדים",
                  pricingSingle: "נוסע בודד",
                  pricing3Adults: "3 מבוגרים",
                  pricing3Adults1Child: "3 מבוגרים + ילד 1",
                  pricing3Adults2Children: "3 מבוגרים + 2 ילדים"
                },
                boardTypes: {
                  none: "ללא",
                  roomOnly: "חדר בלבד",
                  bedBreakfast: "לינה וארוחת בוקר",
                  halfBoard: "חצי פנסיון",
                  fullBoard: "פנסיון מלא",
                  allInclusive: "הכל כלול"
                },
                types: {
                  package: "חבילה",
                  flight: "טיסה",
                  hotel: "מלון",
                  tour: "סיור",
                  cruise: "שייט",
                  custom: "מותאם אישית"
                },
                active: "פעיל",
                activeDescription: "נראה ללקוחות",
                featured: "מובילה",
                featuredDescription: "מודגש ברשימות",
                cancel: "ביטול",
                create: "צור הצעה",
                save: "שמור שינויים"
              },
              images: {
                title: "הוסף תמונות להצעה",
                hint: "תמונות באיכות גבוהה מגדילות הזמנות ב-40%",
                uploadNew: "העלה חדש",
                browseLibrary: "עיין בספרייה",
                uploading: "מעלה תמונות..."
              },
              mediaBrowser: {
                title: "בחר מספריית המדיה",
                selected: "תמונות נבחרו",
                clickToSelect: "לחץ על תמונות לבחירה",
                loading: "טוען קבצי מדיה...",
                noFiles: "לא נמצאו קבצים",
                noFilesHint: "העלה תמונות קודם",
                cancel: "ביטול",
                addImages: "הוסף"
              },
              empty: {
                title: "אין הצעות עדיין",
                description: "צור את ההצעה הראשונה שלך",
                createFirst: "צור הצעה ראשונה"
              },
              delete: {
                title: "מחק הצעה",
                confirm: "האם אתה בטוח שברצונך למחוק",
                warning: "לא ניתן לבטל פעולה זו."
              },
              toast: {
                created: "ההצעה נוצרה בהצלחה!",
                updated: "ההצעה עודכנה בהצלחה!",
                deleted: "ההצעה נמחקה"
              },
              pagination: {
                showing: "מציג",
                of: "מתוך"
              }
            },
            queueModal: {
              title: {
                add: "הוסף תור",
                edit: "ערוך תור"
              },
              form: {
                name: "שם",
                color: "צבע",
                greetingMessage: "הודעת ברכה",
                complationMessage: "הודעת סיום",
                outOfHoursMessage: "הודעה מחוץ לשעות",
                ratingMessage: "הודעת דירוג",
                transferMessage: "הודעת העברה",
                token: "אסימון",
                menuType: "סוג תפריט"
              },
              serviceHours: {
                dayWeek: "יום בשבוע",
                startTimeA: "שעת התחלה - משמרת א'",
                endTimeA: "שעת סיום - משמרת א'",
                startTimeB: "שעת התחלה - משמרת ב'",
                endTimeB: "שעת סיום - משמרת ב'",
                monday: "שני",
                tuesday: "שלישי",
                wednesday: "רביעי",
                thursday: "חמישי",
                friday: "שישי",
                saturday: "שבת",
                sunday: "ראשון"
              },
              menuTypes: {
                auto: "אוטומטי (זיהוי חכם)",
                buttons: "כפתורי תגובה מהירה",
                list: "תפריט רשימה",
                text: "טקסט (קלאסי 1-2-3)"
              },
              buttons: {
                okAdd: "הוסף",
                okEdit: "שמור",
                cancel: "ביטול",
                attach: "צרף קובץ",
                edit: "ערוך",
                duplicate: "שכפל"
              },
              options: {
                title: "אפשרויות",
                notDefined: "כותרת לא מוגדרת",
                message: "הזן את טקסט האפשרות",
                note: {
                  title: "הוסף אפשרויות כדי לבנות בוט צ'אט",
                  content: "אם יש רק אפשרות אחת, היא תבחר באופן אוטומטי, מפעילה את הבוט להגיב עם הודעת האפשרות ולהמשיך הלאה"
                },
                addOpts: "הוסף אפשרויות",
                attendant: "העברה אל:"
              },
              confirmationModal: {
                deleteTitle: "מחק קובץ מצורף",
                deleteMessage: "האם אתה בטוח שברצונך למחוק קובץ מצורף זה?",
                deleteOptionTitle: "מחק שאלת בוט",
                deleteOptionMessage: "האם אתה בטוח שברצונך למחוק שאלת בוט זו? לא ניתן לבטל פעולה זו."
              }
            },
            userModal: {
              title: {
                add: "הוסף משתמש",
                edit: "ערוך משתמש"
              },
              form: {
                name: "שם",
                email: "אימייל",
                password: "סיסמה",
                profile: "פרופיל",
                sales: "מכירות",
                salesHelp: "מונה ידני שמוצג בלוח הדירוג.",
                currency: "מטבע"
              },
              buttons: {
                okAdd: "הוסף",
                okEdit: "שמור",
                save: "שמור",
                cancel: "ביטול"
              },
              success: "המשתמש נשמר בהצלחה."
            },
            scheduleModal: {
              title: {
                add: "שיבוץ חדש",
                edit: "עריכת שיבוץ",
                error: "שגיאת שליחה",
                message: "הודעה"
              },
              form: {
                body: "הודעה",
                contact: "איש קשר",
                sendAt: "תאריך שיבוץ",
                sentAt: "תאריך שליחה",
                saveMessage: "שמור הודעה בכרטיס"
              },
              buttons: {
                okAdd: "הוסף",
                okEdit: "שמור",
                cancel: "ביטול"
              },
              error: "שגיאה",
              contact: "בחר איש קשר",
              success: "השיבוץ נשמר בהצלחה."
            },
            tagModal: {
              title: {
                add: "תג חדש",
                edit: "ערוך תג",
                addKanban: "נתיב חדש",
                editKanban: "ערוך נתיב"
              },
              form: {
                name: "שם",
                color: "צבע",
                kanban: "קנבן"
              },
              buttons: {
                okAdd: "הוסף",
                okEdit: "שמור",
                cancel: "ביטול"
              },
              success: "התג נשמר בהצלחה.",
              successKanban: "הנתיב נשמר בהצלחה."
            },
            kanban: {
              title: "קנבן",
              searchPlaceholder: "חיפוש",
              subMenus: {
                list: "לוח",
                tags: "נתיבים"
              }
            },
            tagsKanban: {
              title: "נתיבים",
              laneDefault: "פתוח",
              confirmationModal: {
                deleteTitle: "האם אתה בטוח שברצונך למחוק נתיב זה?",
                deleteMessage: "פעולה זו לא ניתנת לביטול."
              },
              table: {
                name: "שם",
                color: "צבע",
                tickets: "כרטיסים",
                actions: "פעולות"
              },
              buttons: {
                add: "נתיב חדש"
              },
              toasts: {
                deleted: "הנתיב נמחק בהצלחה."
              }
            },
            campaigns: {
              title: "קמפיינים בוואטסאפ",
              searchPlaceholder: "חיפוש קמפיינים...",
              buttons: {
                add: "קמפיין חדש",
                addRecipients: "הוסף נמענים",
                send: "שלח קמפיין",
                edit: "עריכה",
                delete: "מחיקה",
                viewStats: "צפה בסטטיסטיקות",
                refresh: "רענן",
                contactLists: "רשימות קשר",
                pause: "השהה",
                resume: "המשך",
                stop: "עצור",
                restart: "הפעל מחדש"
              },
              table: {
                name: "שם",
                type: "סוג",
                template: "תבנית",
                whatsapp: "חיבור",
                contactList: "רשימת קשר",
                status: "סטטוס",
                recipients: "נמענים",
                progress: "התקדמות",
                scheduledAt: "מתוזמן",
                completedAt: "הושלם",
                createdAt: "נוצר",
                confirmation: "אישור",
                actions: "פעולות",
                sentAt: "נשלח ב"
              },
              status: {
                draft: "טיוטה",
                scheduled: "מתוזמן",
                sending: "בשליחה",
                paused: "מושהה",
                completed: "הושלם",
                cancelled: "בוטל",
                failed: "נכשל"
              },
              types: {
                marketing: "שיווק",
                service_update: "עדכון שירות"
              },
              dialog: {
                new: "יצירת קמפיין חדש",
                update: "עריכת קמפיין",
                readonly: "קריאה בלבד",
                form: {
                  name: "שם הקמפיין",
                  type: "סוג",
                  template: "תבנית",
                  language: "שפה",
                  whatsapp: "חיבור וואטסאפ",
                  scheduledAt: "תזמון שליחה (אופציונלי)",
                  scheduledAtHint: "השאר ריק לשליחה ידנית",
                  templateParams: "פרמטרים של התבנית",
                  paramPlaceholder: "ערך לפרמטר זה",
                  message1: "הודעה 1",
                  message2: "הודעה 2",
                  message3: "הודעה 3",
                  message4: "הודעה 4",
                  message5: "הודעה 5",
                  confirmationMessage1: "הודעת אישור 1",
                  confirmationMessage2: "הודעת אישור 2",
                  confirmationMessage3: "הודעת אישור 3",
                  confirmationMessage4: "הודעת אישור 4",
                  confirmationMessage5: "הודעת אישור 5",
                  messagePlaceholder: "תוכן ההודעה",
                  status: "סטטוס",
                  confirmation: "אישור",
                  contactList: "רשימת קשר"
                },
                buttons: {
                  add: "צור",
                  edit: "שמור",
                  okadd: "אישור",
                  cancel: "ביטול",
                  restart: "הפעל שליחות מחדש",
                  close: "סגור",
                  attach: "צרף קובץ",
                  import: "ייבוא"
                }
              },
              recipients: {
                title: "הוסף נמענים",
                tabs: {
                  csv: "העלאת CSV",
                  manual: "הזנה ידנית",
                  contacts: "מאנשי קשר"
                },
                csv: {
                  description: "העלה קובץ CSV עם עמודות: phone, name (אופציונלי), var1, var2, var3 (למשתני תבנית)",
                  upload: "לחץ להעלאת קובץ CSV",
                  preview: "תצוגה מקדימה",
                  rows: "שורות",
                  moreRows: "ועוד {{count}} שורות",
                  variables: "משתנים"
                },
                manual: {
                  description: "הזן מספרי טלפון (אחד בכל שורה, או מופרדים בפסיקים). המספרים צריכים להיות בפורמט בינלאומי (לדוגמה: 972501234567).",
                  placeholder: "972501234567\n972502345678\n972503456789",
                  numbersEntered: "{{count}} מספרים הוזנו"
                },
                contacts: {
                  search: "חיפוש אנשי קשר...",
                  selectAll: "בחר הכל",
                  selected: "{{count}} נבחרו",
                  noContacts: "לא נמצאו אנשי קשר"
                },
                importResult: {
                  title: "הייבוא הושלם:",
                  imported: "יובאו",
                  duplicates: "כפילויות",
                  invalid: "לא תקינים",
                  matched: "אנשי קשר שהותאמו",
                  filtered: "סוננו (ללא היסטוריה)"
                },
                safetyFilter: {
                  label: "מסנן בטיחות: רק אנשי קשר עם היסטוריית צ'אט",
                  description: "מגן מפני חסימת הודעות של Meta לאנשי קשר שמעולם לא יצרו קשר עם העסק שלך"
                }
              },
              details: {
                stats: {
                  total: "סה\"כ",
                  pending: "ממתינים",
                  sent: "נשלחו",
                  delivered: "נמסרו",
                  read: "נקראו",
                  failed: "נכשלו"
                },
                info: {
                  template: "תבנית",
                  language: "שפה",
                  whatsapp: "וואטסאפ",
                  created: "נוצר"
                },
                tabs: {
                  all: "כל הנמענים",
                  failed: "נכשלו"
                },
                error: "שגיאה",
                noRecipients: "אין נמענים עדיין. ייבא מ-CSV כדי להוסיף נמענים.",
                cost: {
                  title: "הערכת עלות",
                  perMessage: "עלות להודעה",
                  spent: "הוצאה עד כה",
                  estimated: "עלות מוערכת"
                },
                rates: {
                  delivery: "אחוז מסירה",
                  read: "אחוז קריאה"
                }
              },
              confirmationModal: {
                deleteTitle: "מחיקת קמפיין",
                deleteMessage: "האם אתה בטוח שברצונך למחוק את \"{{name}}\"? פעולה זו לא ניתנת לביטול.",
                sendTitle: "שליחת קמפיין",
                sendMessage: "לשלוח את הקמפיין \"{{name}}\" ל-{{count}} נמענים?",
                stopMessage: "לעצור את הקמפיין \"{{name}}\"? הודעות שלא נשלחו לא ישלחו.",
                restartMessage: "להפעיל מחדש את הקמפיין \"{{name}}\"? נמענים שנכשלו יאופסו."
              },
              toasts: {
                success: "הפעולה הושלמה בהצלחה",
                created: "הקמפיין נוצר בהצלחה",
                updated: "הקמפיין עודכן בהצלחה",
                cancel: "הקמפיין בוטל",
                restart: "הקמפיין הופעל מחדש",
                deleted: "הקמפיין נמחק בהצלחה",
                sending: "שליחת הקמפיין החלה!",
                paused: "הקמפיין הושהה",
                resumed: "הקמפיין ממשיך",
                stopped: "הקמפיין נעצר",
                restarted: "הקמפיין הופעל מחדש בהצלחה",
                importSuccess: "יובאו {{count}} נמענים",
                noRecipients: "אנא הוסף נמענים לפני השליחה",
                fillRequired: "אנא מלא את כל השדות הנדרשים",
                selectRecipients: "אנא בחר לפחות נמען אחד",
                enterNumbers: "אנא הזן לפחות מספר טלפון אחד",
                noData: "אין נתונים תקינים לייבוא",
                filteredNoChatHistory: "סוננו - ללא היסטוריית צ'אט"
              },
              empty: {
                title: "אין קמפיינים עדיין",
                description: "צור את הקמפיין הראשון שלך!"
              }
            },
            followUp: {
              tooltip: "מעקב חכם",
              dialog: {
                title: "מעקב חכם",
                description: "שלח אוטומטית הודעת מעקב אם הלקוח לא מגיב.",
                status: "מעקב פעיל",
                selectTemplate: "בחר תבנית",
                activeTemplate: "תבנית פעילה",
                delay: "שלח אחרי",
                minutes: "דקות",
                hour: "שעה",
                hours: "שעות",
                testMode: "מצב בדיקה",
                willSendAfter5min: "יישלח אוטומטית 5 דקות לאחר ההודעה האחרונה שלך (מצב בדיקה).",
                willSendAfter1h: "יישלח אוטומטית שעה לאחר ההודעה האחרונה שלך אם הלקוח לא עונה.",
                willSendAfter24h: "יישלח אוטומטית 24 שעות לאחר ההודעה האחרונה שלך אם הלקוח לא עונה.",
                close: "סגור",
                customerName: "שם הלקוח",
                customerNameHint: "שם זה ישמש בתבנית ({{1}}). ניתן לערוך במידת הצורך.",
                fillParameters: "מלא את משתני התבנית:",
                parameter: "פרמטר",
                noParameters: "לתבנית זו אין פרמטרים דינמיים."
              },
              success: {
                enabled: "מעקב הופעל!",
                disabled: "מעקב בוטל."
              },
              errors: {
                selectTemplate: "אנא בחר תבנית תחילה."
              }
            },
            campaignsConfig: {
              title: "הגדרות קמפיינים"
            },
            fileModal: {
              title: {
                add: "הוסף רשימת פריטים",
                edit: "ערוך רשימת פריטים"
              },
              buttons: {
                okAdd: "שמור",
                okEdit: "ערוך",
                cancel: "ביטול",
                fileOptions: "הוסף פריט"
              },
              form: {
                name: "שם הפריט",
                message: "פרטי הפריט",
                fileOptions: "מידע נוסף על הפריט",
                extraName: "הערות כלליות על הפריט",
                extraValue: "ערך אופציה"
              },
              success: "רשימת קטלוג נשמרה בהצלחה!"
            },
            files: {
              title: "רשימת קטלוג",
              preview: "תצוגה מקדימה של קובץ",
              notImage: "הקובץ הזה אינו תמונה",
              download: "הורד קובץ",
              table: {
                name: "שם",
                contacts: "אנשי קשר",
                actions: "פעולה",
                view: "הצג תמונה"
              },
              toasts: {
                deleted: "רשימה נמחקה בהצלחה!",
                deletedAll: "כל הרשימות נמחקו בהצלחה!"
              },
              buttons: {
                add: "הוסף",
                deleteAll: "מחק הכל"
              },
              confirmationModal: {
                deleteTitle: "מחיקה",
                deleteAllTitle: "מחק הכל",
                deleteMessage: "האם אתה בטוח שברצונך למחוק את הרשימה הזו?",
                deleteAllMessage: "האם אתה בטוח שברצונך למחוק את כל הרשימות?"
              },
              empty: {
                title: "אין עדיין רשימות קבצים",
                desc: "צור רשימות קבצים מוכנות מראש ושלח אותן ללקוחות בלחיצה — אידיאלי לקטלוגים, מצגות וחומרי שיווק."
              }
            },
            chat: {
              noTicketMessage: "בחר כרטיס כדי להתחיל את השיחה.",
              selectTicket: "בחר כרטיס",
              title: "צ'אט",
              welcomeBack: "ברוך שובך",
              tip1Title: "בחר שיחה",
              tip1Text: "לחץ על כרטיס שיחה ברשימה כדי להתחיל לענות לפניות",
              tip2Title: "תגובות מהירות",
              tip2Text: "השתמש בתגובות מוכנות מראש כדי לחסוך זמן בכל פניה",
              tip3Title: "תהיה הראשון להגיב",
              tip3Text: "תגובה תוך 7 דקות מגדילה את שביעות הרצון של הלקוח ב-32%"
            },
            uploads: {
              titles: {
                titleUploadMsgDragDrop: "גרור ושחרר קבצים בשדה למטה",
                titleFileList: "רשימת קבצים"
              }
            },
            ticketsManager: {
              buttons: {
                newTicket: "חדש"
              }
            },
            ticketsQueueSelect: {
              placeholder: "תורים"
            },
            tickets: {
              title: "כרטיסי צ'אט",
              toasts: {
                deleted: "הכרטיס שעבדת עליו נמחק."
              },
              notification: {
                message: "הודעה מאת"
              },
              tabs: {
                open: {
                  title: "פתוח"
                },
                closed: {
                  title: "סגור"
                },
                search: {
                  title: "חיפוש"
                }
              },
              search: {
                placeholder: "חפש לפי שם, טלפון או טקסט הודעה..."
              },
              buttons: {
                showAll: "הצג הכל"
              }
            },
            ticketsList: {
              pendingHeader: "ממתין",
              assignedHeader: "בטיפול",
              noTicketsTitle: "אין כאן כלום!",
              noTicketsMessage: "לא נמצאו כרטיסים עם סטטוס זה או מונח חיפוש",
              noQueue: "ללא תור",
              buttons: {
                accept: "קבל",
                close: "סגור",
                spy: "רגל כרטיס"
              },
              items: {
                tags: "תגיות"
              },
              userTicket: "שוייך למשתמש:",
              closeBadge: "סגור"
            },
            transferTicketModal: {
              title: "העבר כרטיס",
              fieldLabel: "הקלד כדי לחפש משתמשים",
              fieldQueueLabel: "העבר לתור",
              fieldQueuePlaceholder: "בחר תור",
              noOptions: "לא נמצאו משתמשים עם השם הזה",
              buttons: {
                ok: "העבר",
                cancel: "ביטול"
              }
            },
            newTicketModal: {
              title: "צור כרטיס",
              fieldLabel: "הקלד כדי לחפש איש קשר",
              add: "הוסף",
              buttons: {
                ok: "שמור",
                cancel: "ביטול"
              }
            },
            moveTicket: {
              button: "העבר ל...",
              current: "נוכחי",
              status: {
                open: "פתוח",
                pending: "ממתין",
                closed: "סגור"
              }
            },
            mainDrawer: {
              search: "חיפוש בתפריט...",
              listItems: {
                aiOs: "AI-OS — המוח",
                dashboard: "לוח בקרה",
                connections: "חיבורים",
                tickets: "כרטיסים",
                appointments: "יומן פגישות",
                quickMessages: "תגובות מהירות",
                contacts: "אנשי קשר",
                queues: "תורים ובוט צ'אט",
                tags: "תגיות",
                toDoList: "רשימת מטלות",
                administration: "הגדרות מיוחדות",
                service: "שירות",
                users: "משתמשים",
                settings: "הגדרות",
                helps: "עזרה",
                about: "מובילי מכירות",
                messagesAPI: "API",
                schedules: "משימות מתוזמנות",
                files: "קטלוג",
                annoucements: "הודעות",
                chats: "צ'אט פנימי",
                financial: "כספים",
                logout: "התנתקות",
                management: "ניהול",
                whatsappBackups: "גיבויי וואטסאפ",
                archive: "ארכיון",
                aiDashboard: "לוח בקרה בינה מלאכותית",
                aiSettings: "הגדרות AI",
                voiceSettings: "Voice",
                voiceIntelligence: "Voice Intelligence",
                aiWorkforce: "כוח AI",
                teams: "צוותים",
                campaigns: "קמפיינים",
                offers: "קטלוג הצעות",
                pipelines: "צינורות",
                billing: "חיוב"
              },
              role: {
                administrator: "מנהל",
                supervisor: "מפקח",
                agent: "סוכן"
              },
              workspace: {
                admin: "סביבת עבודה של מנהל",
                supervisor: "סביבת עבודה של מפקח",
                default: "סביבת עבודה"
              },
              appBar: {
                backToAdmin: "חזרה לניהול",
                i18n: {
                  language: "עברית",
                  language_short: "HE"
                },
                user: {
                  profile: "פרופיל",
                  darkmode: "מצב כהה",
                  lightmode: "מצב בהיר",
                  language: "בחר שפה",
                  logout: "התנתקות"
                },
                greetings: {
                  one: "שלום",
                  two: "ברוך הבא ל"
                },
                notRegister: "אין צ'אטים פנימיים"
              }
            },
            messagesAPI: {
              title: "API",
              textMessage: {
                number: "מספר",
                body: "הודעה",
                token: "אסימון רשום"
              },
              mediaMessage: {
                number: "מספר",
                body: "שם קובץ",
                media: "קובץ",
                token: "אסימון רשום"
              }
            },
            notifications: {
              noTickets: "אין התראות."
            },
            quickMessages: {
              success: "ההודעה נמחקה בהצלחה.",
              title: "תגובות מהירות",
              buttons: {
                add: "תשובה חדשה",
                cancel: "ביטול",
                save: "שמור"
              },
              dialog: {
                title: "הודעה מהירה",
                shortcode: "קיצור",
                message: "תגובה"
              },
              confirmationModal: {
                message: "האם ברצונך באמת למחוק רשומה זו?",
                delete: "מחק רשומה"
              },
              table: {
                shortcut: "קיצור",
                message: "הודעה",
                actions: "פעולות"
              },
              empty: {
                title: "אין עדיין תגובות מהירות",
                desc: "צור תגובות מוכנות שתוכל לשלוח בלחיצה כשאתה עונה ללקוחות. חוסך זמן בכל פניה ושומר על שפה אחידה לצוות שלך.",
                cta: "צור תגובה מהירה ראשונה"
              },
              samples: {
                welcome: "שלום! ברוכים הבאים ל-GoDeal. אני כאן לעזור — איך אוכל לסייע היום? 👋",
                hours: "שעות הפעילות שלנו: ראשון–חמישי 09:00–18:00, שישי 09:00–13:00.",
                thanks: "תודה על פנייתך! אחזור אליך בהקדם עם תשובה מסודרת. 🙏"
              }
            },
            toDoList: {
              confirmDelete: "למחוק את \"{{title}}\"? לא ניתן לבטל.",
              title: "ניהול משימות",
              tasksCompleted: "משימות הושלמו",
              reminder: "תזכורת",
              dueIn: "בעוד",
              hours: "שעות",
              reminderEnabled: "תזכורת מופעלת",
              stats: {
                total: "סה״כ",
                active: "פעילות",
                completed: "הושלמו",
                overdue: "באיחור"
              },
              tabs: {
                all: "הכל",
                active: "פעילות",
                completed: "הושלמו",
                overdue: "באיחור"
              },
              filters: {
                allPriorities: "כל העדיפויות",
                allTypes: "כל הסוגים"
              },
              sort: {
                newest: "החדשות ראשונות",
                priority: "לפי עדיפות",
                dueDate: "לפי תאריך יעד",
                title: "לפי כותרת"
              },
              priority: {
                high: "גבוהה",
                medium: "בינונית",
                low: "נמוכה",
                urgent: "דחוף"
              },
              dates: {
                today: "היום",
                tomorrow: "מחר"
              },
              form: {
                label: "צור משימה חדשה",
                placeholder: "הזן משימה",
                title: "כותרת",
                description: "תיאור",
                priority: "עדיפות",
                dueDate: "תאריך יעד",
                reminderOn: "🔔 תזכורת פעילה (24 שעות לפני)",
                reminderOff: "🔕 הפעל תזכורת",
                category: "קטגוריה",
                noCategory: "ללא קטגוריה",
                reminderDate: "תאריך תזכורת",
                visibility: "נראות",
                assignTo: "הקצה ל",
                myself: "לעצמי",
                team: "צוות",
                selectTeam: "בחר צוות",
                queue: "תור",
                selectQueue: "בחר תור",
                shareWith: "שתף עם",
                selectUsers: "בחר משתמשים"
              },
              table: {
                task: "משימה",
                date: "תאריך יצירה",
                actions: "פעולות"
              },
              buttons: {
                add: "הוסף משימה",
                save: "שמור",
                cancel: "ביטול",
                newTask: "משימה חדשה",
                createFirst: "צור את המשימה הראשונה שלך"
              },
              dialog: {
                newTask: "משימה חדשה",
                editTask: "ערוך משימה"
              },
              actions: {
                markComplete: "סמן כהושלם",
                markIncomplete: "סמן כלא הושלם",
                edit: "ערוך",
                delete: "מחק",
                refresh: "רענן",
                complete: "סמן כהושלם",
                reopen: "פתח מחדש"
              },
              messages: {
                created: "המשימה נוצרה בהצלחה",
                updated: "המשימה עודכנה בהצלחה",
                deleted: "המשימה נמחקה",
                completed: "הושלם!"
              },
              errors: {
                titleRequired: "נדרשת כותרת משימה",
                loadFailed: "טעינת המשימות נכשלה",
                saveFailed: "שמירת המשימה נכשלה",
                updateFailed: "עדכון המשימה נכשל",
                deleteFailed: "מחיקת המשימה נכשלה"
              },
              empty: {
                noTasks: "אין משימות עדיין. צור את הראשונה!",
                noCompleted: "אין משימות שהושלמו עדיין",
                noOverdue: "מעולה! אין משימות באיחור"
              },
              status: {
                pending: "ממתין",
                in_progress: "בטיפול",
                completed: "הושלם",
                cancelled: "בוטל"
              },
              visibility: {
                personal: "אישי",
                personalDesc: "רק אתה רואה",
                shared: "משותף",
                sharedDesc: "שתף עם משתמשים נבחרים",
                team: "צוות",
                teamDesc: "כל חברי הצוות רואים",
                queue: "תור",
                queueDesc: "כל המשתמשים בתור רואים"
              },
              noAssignee: "לא הוקצה",
              notifications: {
                newTaskAssigned: "משימה חדשה הוקצתה לך"
              },
              comments: {
                title: "תגובות",
                noComments: "אין תגובות עדיין",
                placeholder: "כתוב תגובה...",
                added: "התגובה נוספה",
                deleted: "התגובה נמחקה",
                addFailed: "הוספת התגובה נכשלה",
                deleteFailed: "מחיקת התגובה נכשלה",
                delete: "מחק תגובה",
                unknownUser: "משתמש לא ידוע"
              }
            },
            contactLists: {
              title: "רשימות אנשי קשר",
              table: {
                name: "שם",
                contacts: "אנשי קשר",
                actions: "פעולות"
              },
              buttons: {
                add: "רשימה חדשה"
              },
              dialog: {
                name: "שם",
                company: "חברה",
                okEdit: "ערוך",
                okAdd: "הוסף",
                add: "הוסף",
                edit: "ערוך",
                cancel: "ביטול"
              },
              confirmationModal: {
                deleteTitle: "מחיקה",
                deleteMessage: "פעולה זו לא ניתנת לביטול."
              },
              toasts: {
                deleted: "רשומה נמחקה"
              }
            },
            contactListItems: {
              title: "אנשי קשר",
              searchPlaceholder: "חיפוש",
              buttons: {
                add: "חדש",
                lists: "רשימות",
                import: "ייבוא"
              },
              dialog: {
                name: "שם",
                number: "מספר",
                whatsapp: "WhatsApp",
                email: "אימייל",
                okEdit: "ערוך",
                okAdd: "הוסף",
                add: "הוסף",
                edit: "ערוך",
                cancel: "ביטול"
              },
              table: {
                name: "שם",
                number: "מספר",
                whatsapp: "WhatsApp",
                email: "אימייל",
                actions: "פעולות"
              },
              confirmationModal: {
                deleteTitle: "מחיקה",
                deleteMessage: "פעולה זו לא ניתנת לביטול.",
                importMessage: "האם ברצונך לייבא את אנשי הקשר מגליון האלקטרוני הזה?",
                importTitlte: "ייבוא"
              },
              toasts: {
                deleted: "רשומה נמחקה"
              }
            },
            announcements: {
              title: "הודעות",
              searchPlaceholder: "חיפוש",
              zero: "אין הודעות",
              noRecords: "אין רישום",
              noFiles: "אין קבצים מצורפים",
              empty: {
                title: "אין הודעות פעילות",
                desc: "הודעות פנימיות שמופיעות לכל הצוות — מושלם לעדכוני נהלים, שינויים ארגוניים והכרזות חשובות."
              },
              priority: {
                high: "גבוהה",
                medium: "בינונית",
                low: "נמוכה"
              },
              status: {
                active: "פעיל",
                inactive: "לא פעיל"
              },
              buttons: {
                add: "הוסף הודעה חדשה",
                contactLists: "רשימות הודעות"
              },
              table: {
                priority: "עדיפות",
                title: "כותרת",
                text: "תוכן",
                mediaName: "קובץ",
                status: "מצב",
                actions: "פעולות"
              },
              dialog: {
                edit: "עריכת הודעה",
                add: "הוספת הודעה חדשה",
                update: "עריכת הודעה",
                readonly: "לצפייה בלבד",
                form: {
                  priority: "עדיפות",
                  title: "כותרת",
                  text: "תוכן",
                  mediaPath: "קובץ",
                  status: "מצב",
                  options: {
                    active: "פעיל",
                    inactive: "לא פעיל",
                    high: "גבוהה",
                    mid: "בינונית",
                    low: "נמוכה"
                  }
                },
                buttons: {
                  add: "הוסף",
                  edit: "ערוך",
                  okadd: "אישור",
                  cancel: "ביטול",
                  close: "סגור",
                  attach: "צרף קובץ"
                }
              },
              confirmationModal: {
                deleteTitle: "מחיקה",
                deleteMessage: "פעולה זו לא ניתנת לביטול."
              },
              toasts: {
                success: "הפעולה בוצעה בהצלחה",
                deleted: "רשומה נמחקה"
              }
            },
            queues: {
              title: "תורים וצ'אטבוט",
              table: {
                name: "שם",
                color: "צבע",
                greeting: "הודעת ברכה",
                actions: "פעולות",
                orderQueue: "מיון תור (צ'אטבוט)"
              },
              buttons: {
                add: "הוסף תור"
              },
              confirmationModal: {
                deleteTitle: "מחיקה",
                deleteMessage: "האם אתה בטוח? פעולה זו לא ניתנת לביטול! הכרטיסים מתוך התור ימשיכו לקיים, אך לא יהיה להם תור מוקצה יותר."
              }
            },
            queueSelect: {
              inputLabel: "תורים"
            },
            queueOptions: {
              forward: "קישור קו"
            },
            users: {
              title: "משתמשים",
              role: {
                admin: "מנהל",
                supervisor: "מפקח",
                user: "משתמש"
              },
              status: {
                online: "מחובר",
                offline: "לא מחובר"
              },
              table: {
                name: "שם",
                email: "אימייל",
                profile: "פרופיל",
                lastLogin: "כניסה אחרונה",
                actions: "פעולות"
              },
              buttons: {
                add: "הוסף משתמש"
              },
              toasts: {
                deleted: "המשתמש נמחק בהצלחה."
              },
              confirmationModal: {
                deleteTitle: "מחיקה",
                deleteMessage: "כל נתוני המשתמש יאבדו. הכרטיסים הפתוחים של משתמש זה יועברו לתור."
              },
              activity: {
                title: "פעילות משתמש",
                filters: {
                  today: "היום",
                  last7: "7 ימים אחרונים",
                  last14: "14 ימים אחרונים",
                  last21: "21 ימים אחרונים",
                  last30: "30 ימים אחרונים",
                  month: "חודש ספציפי"
                },
                kpis: {
                  lastLogin: "כניסה אחרונה",
                  totalLogins: "סה״כ כניסות",
                  totalConnected: "סה״כ זמן מחובר",
                  totalActive: "סה״כ זמן פעיל",
                  totalIdle: "סה״כ זמן בהמתנה",
                  avgSession: "ממוצע משך סשן",
                  avgDaily: "ממוצע פעילות יומית"
                },
                sessions: {
                  title: "פרטי סשנים",
                  date: "תאריך",
                  login: "כניסה",
                  logout: "יציאה",
                  duration: "משך",
                  active: "פעיל",
                  idle: "המתנה",
                  actions: "פעולות",
                  noData: "אין נתוני פעילות בתקופה שנבחרה",
                  stillActive: "פעיל"
                }
              }
            },
            helps: {
              title: "מרכז העזרה"
            },
            schedules: {
              title: "משימות מתוזמנות",
              confirmationModal: {
                deleteTitle: "האם אתה בטוח שברצונך למחוק משימה זו?",
                deleteMessage: "פעולה זו לא ניתנת לביטול."
              },
              empty: {
                title: "אין תזמונים עדיין",
                desc: "תזמן הודעות מראש ושלח אותן ללקוחות בדיוק בזמן הנכון — ללא צורך לזכור או להיות מחובר."
              },
              table: {
                contact: "איש קשר",
                body: "הודעה",
                sendAt: "תאריך תזמון",
                sentAt: "תאריך שליחה",
                status: "מצב",
                actions: "פעולות",
                sent: "נשלח",
                pending: "ממתין",
                process: "בעיבוד",
                statusMap: {
                  PENDENTE: "ממתין",
                  AGENDADA: "מתוזמן",
                  ENVIADA: "נשלח",
                  ERRO: "שגיאה"
                }
              },
              tabs: {
                all: "הכל",
                active: "פעיל",
                done: "בוצע",
                noResults: "אין משימות בקטגוריה זו"
              },
              buttons: {
                add: "משימה חדשה"
              },
              toasts: {
                deleted: "המשימה נמחקה בהצלחה."
              }
            },
            tags: {
              title: "תגיות",
              confirmationModal: {
                deleteTitle: "האם אתה בטוח שברצונך למחוק תג זה?",
                deleteMessage: "פעולה זו לא ניתנת לביטול."
              },
              table: {
                name: "שם",
                color: "צבע",
                tickets: "רשומות",
                actions: "פעולות",
                id: "מזהה"
              },
              buttons: {
                add: "תג חדש"
              },
              toasts: {
                deleted: "התג נמחק בהצלחה."
              }
            },
            whatsappBackups: {
              title: "גיבויי וואטסאפ",
              archive: "ארכיון",
              messages: "הודעות",
              contacts: "אנשי קשר",
              media: "מדיה",
              tabs: {
                all: "הכל",
                chats: "צ'אטים",
                media: "מדיה"
              },
              buttons: {
                upload: "העלה קבצים",
                uploadFolder: "העלה תיקייה",
                uploading: "מעלה...",
                download: "הורד",
                parse: "נתח",
                preview: "תצוגה מקדימה",
                restore: "שחזר",
                restoring: "משחזר...",
                search: "חפש",
                searching: "מחפש...",
                validate: "אמת",
                delete: "מחק",
                close: "סגור",
                cancel: "ביטול",
                deleteSelected: "מחק נבחרים",
                deleting: "מוחק...",
                clearSelection: "נקה"
              },
              preview: {
                title: "תצוגה מקדימה של צ'אט",
                loading: "טוען תצוגה מקדימה...",
                noData: "אין נתונים לתצוגה",
                dateRange: "תאריך התחלה",
                participants: "משתתפים",
                showingMessages: "מציג {{shown}} מתוך {{total}} הודעות",
                loadMore: "טען עוד 200",
                loadAll: "טען הכל"
              },
              batchUpload: {
                uploading: "מעלה קבצים...",
                progress: "התקדמות",
                files: "קבצים",
                batch: "אצווה",
                success: "הצליח",
                failed: "נכשל",
                extractedFromZip: "חולץ מ-ZIP",
                emptyZip: "קבצי ZIP ללא צ'אטים"
              },
              toasts: {
                downloadSuccess: "הקובץ הורד בהצלחה",
                parseSuccess: "הגיבוי נותח בהצלחה",
                deleteSuccess: "הגיבוי נמחק בהצלחה",
                bulkDeleteSuccess: "{{count}} גיבויים נמחקו בהצלחה",
                restoreSuccess: "הגיבוי שוחזר בהצלחה",
                noValidFiles: "לא נמצאו קבצי גיבוי תקינים. פורמטים נתמכים: .txt, .json, .html, .zip",
                noFilesProcessed: "לא עובדו קבצי גיבוי. קבצי ZIP עשויים להכיל רק קבצי מדיה (תמונות, סרטונים) - לא נמצאו יצואי צ'אט.",
                uploadCancelled: "ההעלאה בוטלה",
                uploadSuccess: "הגיבוי הועלה בהצלחה",
                uploadError: "שגיאה בהעלאת גיבוי",
                validateSuccess: "הגיבוי אומת בהצלחה",
                restoreError: "שגיאה בשחזור גיבוי"
              },
              filters: {
                statusLabel: "סטטוס",
                allStatuses: "כל הסטטוסים",
                phonePlaceholder: "סנן לפי מספר טלפון"
              },
              confirmationModal: {
                deleteTitle: "מחק גיבוי",
                deleteMessage: "האם אתה בטוח שברצונך למחוק גיבוי זה? פעולה זו אינה ניתנת לביטול.",
                bulkDeleteTitle: "מחק גיבויים נבחרים",
                bulkDeleteMessage: "האם אתה בטוח שברצונך למחוק {{count}} גיבויים נבחרים? פעולה זו אינה ניתנת לביטול."
              },
              selection: {
                selected: "{{count}} נבחרו"
              },
              table: {
                fileName: "שם קובץ",
                status: "סטטוס",
                size: "גודל",
                format: "פורמט",
                messages: "הודעות",
                contacts: "אנשי קשר",
                phone: "מספר טלפון",
                uploaded: "הועלה",
                actions: "פעולות"
              },
              status: {
                uploaded: "הועלה",
                processing: "מעבד",
                parsed: "נותח",
                failed: "נכשל",
                validated: "אומת"
              },
              dragDrop: {
                title: "גרור ושחרר קובץ גיבוי כאן",
                dropping: "שחרר קובץ כאן",
                subtitle: "או לחץ לעיון בקבצים",
                formats: "פורמטים נתמכים: .txt, .json, .html, .zip, .db, .crypt12-15"
              },
              helper: {
                restoreInfo: "השיחות ששוחזרו מופיעות ב‑Tickets → מסנן \"Closed\". כשהלקוח כותב שוב הכרטיס האחרון נפתח מחדש כדי להשאיר את כל ההיסטוריה באותו דיון."
              },
              search: {
                title: "חיפוש בארכיון",
                byText: "חפש לפי טקסט",
                bySender: "חפש לפי שולח",
                byDate: "חפש לפי תאריך",
                placeholder: "חפש לפי שם או טלפון",
                results: "תוצאות חיפוש"
              },
              restore: {
                title: "שחזור גיבוי לצ'אטים",
                description: "פעולה זו תייבא את כל ההודעות מהגיבוי לטיקטים פעילים.",
                selectConnection: "חיבור WhatsApp",
                customerPhone: "מספר טלפון של הלקוח",
                customerPhoneHelper: "הזן את מספר הטלפון של הלקוח מהצ'אט הזה (עם קידומת מדינה, למשל 972936226260)",
                enterPhone: "אנא הזן מספר טלפון של הלקוח",
                foundContact: "נמצא איש קשר",
                customerInChat: "לקוח בצ'אט",
                notFoundInContacts: "לא נמצא באנשי קשר, הזן מספר ידנית",
                autoFilled: "מולא אוטומטית מאיש קשר שנמצא. ניתן לשנות במידת הצורך.",
                file: "קובץ",
                messages: "הודעות",
                contacts: "אנשי קשר"
              },
              mainTabs: {
                backups: "גיבויים",
                history: "היסטוריית שחזור"
              },
              offlineMode: {
                warning: "אתה במצב לא מקוון. מציג נתונים מהמטמון."
              },
              history: {
                title: "היסטוריית שחזור",
                empty: "אין היסטוריית שחזור עדיין",
                emptyHint: "שיחות משוחזרות יופיעו כאן",
                fileName: "קובץ גיבוי",
                phone: "טלפון",
                contact: "איש קשר",
                messages: "הודעות",
                restoredAt: "שוחזר ב",
                result: "תוצאה",
                success: "הצלחה",
                failed: "נכשל",
                clearHistory: "נקה היסטוריה",
                cleared: "ההיסטוריה נוקתה"
              }
            },
            mergeBackupModal: {
              title: "ייבוא היסטוריית צ'אט",
              selectBackup: "בחר גיבוי לייבוא",
              selectBackupHint: "בחר קובץ גיבוי שמתאים למספר הטלפון של איש הקשר:",
              noBackups: "לא נמצאו גיבויים תואמים",
              noBackupsHint: "העלה גיבויים עם מספרי טלפון בשם הקובץ כדי לאפשר ייבוא",
              phone: "טלפון",
              merge: "ייבוא היסטוריה",
              merging: "מייבא...",
              close: "סגור",
              success: "היסטוריית הצ'אט יובאה בהצלחה!",
              mergeComplete: "הייבוא הושלם",
              messagesCreated: "הודעות שיובאו",
              messagesSkipped: "כפילויות שדולגו"
            },
            settings: {
              customDomain: {
                tab: "דומיין מותאם אישית",
                title: "דומיין מותאם אישית",
                subtitle: "הגישו את מערכת ה-CRM בכתובת משלכם, למשל crm.yourbrand.com. הוסיפו את הדומיין, הפנו את רשומות ה-DNS אלינו, ואנחנו ננפיק את אישור ה-HTTPS באופן אוטומטי.",
                notEntitled: "דומיינים מותאמים אישית זמינים בחבילה גבוהה יותר. צרו איתנו קשר כדי להגיש את ה-CRM בכתובת משלכם.",
                step1: "1. הזינו את הדומיין שלכם",
                domainLabel: "דומיין",
                add: "הוספת דומיין",
                step2: "2. הוסיפו את רשומות ה-DNS הבאות אצל ספק הדומיין",
                dnsPropagation: "עדכוני DNS עשויים להתעדכן עד שעה. כשהרשומות פעילות, לחצו על בדיקה.",
                dnsNotFound: "הרשומות עדיין לא זוהו — בדקו אותן שוב ונסו שנית.",
                check: "בדיקת DNS",
                remove: "הסרה",
                activePrefix: "ה-CRM שלכם פעיל בכתובת",
                open: "פתיחה",
                statusActive: "פעיל",
                statusDisabled: "לא מוגדר",
                statusSsl: "מנפיק אישור",
                statusDns: "ממתין ל-DNS",
                copy: "העתקת ערך",
                copied: "הועתק",
                reserved: "הדומיין נשמר — הוסיפו את רשומות ה-DNS למטה.",
                removeConfirm: "להסיר את הדומיין המותאם אישית?",
                removed: "הדומיין המותאם אישית הוסר.",
              },
              success: "ההגדרות נשמרו בהצלחה.",
              update: "טוען עדכון",
              title: "הגדרות",
              updateSuccess: "ההגדרות נשמרו בהצלחה.",
              pushNotifications: {
                title: "התראות פוש לנייד",
                subtitle: "ניהול התראות פוש באפליקציית הנייד",
                toggle: {
                  title: "התראות פוש",
                  helper: "הגדרה זו משפיעה רק על אפליקציית הנייד."
                },
                scope: {
                  title: "אילו הודעות יפעילו התראה",
                  all: "כל ההודעות הנכנסות",
                  byTag: "רק שיחות עם תגים נבחרים"
                },
                tags: {
                  title: "תגים נבחרים",
                  helper: "התראה תישלח רק עבור שיחות שמשויך להן אחד מהתגים שנבחרו.",
                  placeholder: "בחרו תגים",
                  empty: "אין תגים זמינים — צרו תגים תחילה"
                }
              },
              apiToken: "API Token",
              apiTokenEmpty: "טרם נוצר טוקן",
              copy: "העתק",
              generateToken: "צור טוקן",
              tokenCopied: "הטוקן הועתק ללוח",
              group: {
                general: "כללי",
                generalDesc: "הגדרות בסיס של הבוט",
                groups: "קבוצות",
                groupsDesc: "הגדרות קבוצות והתראות",
                confidenciality: "סודיות",
                api: "API",
                apiDesc: "אינטגרציה וגישה",
                serveradmin: "ניהול שרת"
              },
              IgnoreGroupMessages: {
                title: "התעלמות מהודעות בקבוצה",
                options: {
                  enabled: "מופעל",
                  disabled: "מושבת"
                }
              },
              soundGroupNotifications: {
                title: "צליל בהתראות קבוצה",
                options: {
                  enabled: "מופעל",
                  disabled: "מושבת"
                }
              },
              groupsTab: {
                title: "לשונית קבוצות",
                options: {
                  enabled: "מופעל",
                  disabled: "מושבת"
                }
              },
              AutomaticChatbotOutput: {
                title: "פלט אוטומטי של צ'אטבוט",
                options: {
                  enabled: "מופעל",
                  disabled: "מושבת"
                }
              },
              chatbotResetDays: {
                title: "איפוס צ'אטבוט אוטומטי",
                helper: "ימי חוסר פעילות לפני הפעלה מחדש של הבוט",
                options: {
                  never: "אף פעם",
                  day: "יום",
                  days: "ימים"
                }
              },
              systemLanguage: {
                title: "שפת מערכת",
                helper: "לפי דפדפן. שינוי יטען מחדש את העמוד.",
                updateSuccess: "השפה עודכנה. טוען מחדש..."
              },
              QuickMessages: {
                title: "הודעות מהירות",
                options: {
                  enabled: "עבור חברה",
                  disabled: "עבור משתמש"
                }
              },
              keepQueueAndUser: {
                title: "שמור תור ומשתמש בכרטיס סגור",
                options: {
                  enabled: "מופעל",
                  disabled: "מושבת"
                }
              },
              Options: {
                title: "אפשרויות"
              },
              GPT: {
                title: "GPT AI"
              },
              Templates: {
                title: "תבניות"
              },
              Archive: {
                title: "ארכיון"
              },
              Companies: {
                title: "חברות"
              },
              Plans: {
                title: "תוכניות"
              },
              Whitelabel: {
                title: "צבעים ולוגו"
              },
              Subscriptions: {
                title: "מנויים"
              },
              Payments: {
                title: "תשלומים"
              },
              sections: {
                general: "כללי",
                billing: "תשלומים",
                admin: "ניהול-על"
              },
              companies: {
                subtitle: "{{active}} פעילות · {{expiring}} פגות תוקף בתוך 7 ימים",
                add: "הוסף חברה",
                searchPlaceholder: "חיפוש לפי שם, אימייל או טלפון...",
                statusLabel: "סטטוס",
                allStatuses: "כל הסטטוסים",
                activeOnly: "פעילות בלבד",
                blockedOnly: "חסומות בלבד",
                planLabel: "תוכנית",
                allPlans: "כל התוכניות",
                statusActive: "פעילה",
                statusBlocked: "חסומה",
                col: {
                  company: "חברה",
                  contact: "איש קשר",
                  plan: "תוכנית",
                  status: "סטטוס",
                  created: "נוצרה",
                  expiration: "פג תוקף",
                  actions: "פעולות"
                }
              },
              plans: {
                subtitle: "{{publicCount}} ציבוריות · {{privateCount}} פרטיות",
                add: "הוסף תוכנית",
                searchPlaceholder: "חיפוש לפי שם תוכנית...",
                visibilityLabel: "נראות",
                allPlans: "כל התוכניות",
                publicOnly: "ציבוריות בלבד",
                privateOnly: "פרטיות בלבד",
                public: "ציבורית",
                private: "פרטית",
                month: "חודש",
                customPricing: "מחיר מותאם אישית",
                users: "משתמשים",
                connections: "חיבורי WhatsApp",
                queues: "תורים",
                editTooltip: "עריכת תוכנית",
                deleteTooltip: "מחיקת תוכנית"
              },
              whitelabel: {
                identity: {
                  title: "זהות",
                  desc: "שם המותג המוצג בכל המערכת"
                },
                colors: {
                  title: "צבעי מותג",
                  desc: "הצבע הראשי לכפתורים, לשוניות ואלמנטים"
                },
                assets: {
                  title: "נכסי מותג",
                  desc: "לוגואים ו-favicon למצב בהיר/כהה"
                },
                appName: "שם המערכת",
                primaryLight: "צבע עיקרי — מצב בהיר",
                primaryDark: "צבע עיקרי — מצב כהה",
                logoLight: "לוגו בהיר",
                logoDark: "לוגו כהה",
                favicon: "Favicon",
                upload: "העלאה"
              }
            },
            contactWhatsappUsername: {
              label: "שם משתמש WhatsApp (@username)",
              placeholder: "john.doe",
              helper: "אופציונלי — שם ייחודי ב-WhatsApp (3-35 תווים, אותיות קטנות / מספרים / נקודות / קווים תחתונים)",
              validation: {
                tooShort: "שם משתמש חייב להכיל לפחות 3 תווים",
                tooLong: "שם משתמש יכול להכיל עד 35 תווים",
                invalidChars: "שם משתמש יכול להכיל רק אותיות קטנות, מספרים, נקודות וקווים תחתונים",
                noWww: "שם משתמש לא יכול להתחיל ב-www.",
                noDomain: "שם משתמש לא יכול להסתיים עם סיומת דומיין (.com, .net...)"
              }
            },
            messageInput: {
              chooseEmoji: "בחר אימוג'י",
              noTemplates: "אין תבניות זמינות",
              syncTemplates: "סנכרן תבניות מההגדרות",
              emojiPicker: {
                search: "חיפוש",
                clear: "נקה",
                notfound: "לא נמצאו אימוג'ים",
                categories: {
                  search: "תוצאות חיפוש",
                  recent: "נפוצים",
                  smileys: "פרצופים",
                  people: "אנשים",
                  nature: "טבע",
                  foods: "אוכל",
                  activity: "פעילויות",
                  places: "מקומות",
                  objects: "חפצים",
                  symbols: "סמלים",
                  flags: "דגלים"
                }
              }
            },
            time: {
              hourAbbr: "ש׳",
              minuteAbbr: "ד׳",
              dayAbbr: "ימ׳"
            },
            messagesList: {
              ack: {
                failed: "לא נמסר — ייתכן שמטא חסמה את ההודעה או שמספר הטלפון אינו תקף",
                pending: "ממתין לשליחה...",
                sent: "נשלח לשרת WhatsApp",
                delivered: "נמסר לנייד הלקוח",
                read: "נקרא על ידי הלקוח"
              },
              edited: "נערך",
              quotedImage: "תמונה",
              quotedVideo: "סרטון",
              quotedAudio: "הודעת קול",
              quotedDocument: "מסמך",
              quotedSticker: "מדבקה",
              replyToYou: "אתה",
              header: {
                assignedTo: "שוייך ל:",
                today: "היום",
                yesterday: "אתמול",
                selected: "נבחרו",
                buttons: {
                  return: "חזרה",
                  resolve: "פתרון",
                  reopen: "פתיחה מחדש",
                  accept: "קבלה",
                  disableAI: "כבה AI",
                  enableAI: "הפעל AI",
                  markAsUnread: "סמן כלא נקרא"
                }
              },
              invalidVCard: "נתוני כרטיס ביקור לא תקינים",
              messageContact: "שלח הודעה",
              addToContacts: "הוסף לאנשי קשר",
              contactAdded: "איש הקשר נוסף בהצלחה!",
              contactAddError: "שגיאה בהוספת איש קשר",
              contactExists: "איש קשר זה כבר קיים ברשימת אנשי הקשר שלך.",
              noPhoneNumber: "מספר טלפון לא זמין"
            },
            contactDrawerSections: {
              noLinkedChannels: "אין ערוצים מקושרים",
              openChat: "פתח שיחה",
              disconnectChannel: "נתק ערוץ",
              channelIdPlaceholder: "מזהה ערוץ (טלפון / PSID / אימייל)",
              cancel: "ביטול",
              connect: "חבר",
              connectNewChannel: "חבר ערוץ חדש",
              statusOpen: "פתוח",
              statusPending: "ממתין",
              statusClosed: "סגור",
              noTicketHistory: "אין היסטוריית שיחות",
              totalTickets: "שיחות סה\"כ",
              openTickets: "פתוחות",
              channels: "ערוצים",
              customerSince: "לקוח מאז",
              communicationChannels: "ערוצי תקשורת",
              customerJourney: "מסע הלקוח"
            },
            voiceTimeline: {
              statusCompleted: "הסתיימה",
              statusNoAnswer: "לא נענתה",
              statusBusy: "תפוס",
              statusFailed: "נכשלה",
              statusActive: "בשיחה",
              statusRinging: "מצלצל",
              statusQueued: "מתקשר",
              outcomeSale: "מכירה",
              outcomeFollowUp: "מעקב",
              outcomeSupport: "תמיכה",
              outcomePayment: "תשלום",
              outcomeComplaint: "תלונה",
              outcomeNoAnswer: "אין מענה",
              sentimentPositive: "חיובי",
              sentimentNeutral: "ניטרלי",
              sentimentNegative: "שלילי",
              sentimentUrgent: "דחוף",
              intentSales: "מכירה",
              intentSupport: "תמיכה",
              intentPayment: "תשלום",
              intentComplaint: "תלונה",
              intentInformation: "מידע",
              minShort: "ד׳",
              secShort: "ש׳",
              seconds: "שניות",
              outgoing: "שיחה יוצאת",
              incoming: "שיחה נכנסת",
              recorded: "הוקלטה",
              recording: "הקלטה",
              listenRecording: "האזן להקלטה",
              aiAnalysis: "ניתוח AI",
              transcript: "תמלול",
              transcribing: "מתמלל…",
              createTranscript: "צור תמלול",
              analyzing: "מנתח…",
              analyzeCall: "נתח שיחה",
              noRecording: "אין הקלטה לשיחה זו.",
              transcriptNotFound: "לא נמצא תמלול (ייתכן שהשיחה קצרה מדי או ללא דיבור).",
              quickCharge: "חיוב מהיר",
              followUpAction: "מעקב ופעולה"
            },
            channelFilter: {
              showAll: "הצג הכל",
              channelLabel: "ערוץ:",
              label: "ערוצים",
              all: "הצג הכל",
              whatsapp: "WhatsApp",
              facebook: "Messenger",
              instagram: "Instagram",
              email: "אימייל",
              telegram: "טלגרם",
              businessApi: "WhatsApp Business"
            },
            messagesInput: {
              micRequiresHttps: "הקלטה קולית דורשת חיבור מאובטח (HTTPS) והרשאת מיקרופון",
              placeholderOpen: "הקלד הודעה",
              placeholderClosed: "פתח או קבל מחדש את הכרטיס הזה כדי לשלוח הודעה.",
              signMessage: "חתום",
              preview: {
                titleOne: "שליחת מדיה",
                titleMulti: "שליחת מדיה",
                captionPlaceholder: "הוסף כיתוב (אופציונלי)...",
                cancel: "ביטול",
                send: "שלח",
                sending: "שולח...",
                oversizedOne: "קובץ אחד גדול מ-16MB ועלול להידחות.",
                oversizedMany: "מספר קבצים גדולים מ-16MB ועלולים להידחות."
              }
            },
            message: {
              edited: "ערוך",
              forwarded: "הועבר",
              from: "מ"
            },
            ticketMessages: {
              dialog: {
                buttons: {
                  close: "סגור"
                }
              }
            },
            quickCharge: {
              button: "חיוב מהיר",
              title: "חיוב מהיר",
              customer: "לקוח",
              amount: "סכום (₪)",
              reason: "סיבת החיוב",
              defaultReason: "תשלום על שירות",
              create: "צור דרישת תשלום",
              cancel: "ביטול",
              created: "דרישת התשלום נוצרה",
              linkHint: "שלח את הלינק ללקוח בצ'אט או העתק",
              noLink: "דרישת התשלום נוצרה, אך לא הוגדר חשבון Tranzila ליצירת לינק.",
              noLinkButCreated: "נוצר — הגדר Tranzila כדי לקבל לינק",
              done: "סגור",
              copy: "העתק לינק",
              copied: "הלינק הועתק",
              sendToChat: "שלח בצ'אט",
              sent: "הלינק נשלח ללקוח",
              chatPrefix: "לתשלום מאובטח על סך",
              invalidAmount: "נא להזין סכום תקין"
            },
            errorBoundary: {
              pageTitle: "משהו השתבש בטעינת המסך",
              pageBody: "נסה לרענן. שאר המערכת ממשיכה לעבוד כרגיל.",
              reload: "רענן",
              sectionFailed: "לא ניתן לטעון אזור זה כרגע."
            },
            voiceIntelligence: {
              title: "Voice Intelligence — מרכז שליטה",
              calls: {
                filters: {
                  search: "חיפוש",
                  agent: "נציג",
                  outcome: "תוצאה",
                  has: "כולל",
                  all: "הכל",
                  hasRecording: "עם הקלטה",
                  hasTranscript: "עם תמלול",
                  hasAnalysis: "עם ניתוח AI",
                  qa: "בקרת איכות",
                  noOutcome: "ללא תוצאה",
                  noTranscript: "ללא תמלול",
                  noAnalysis: "ללא ניתוח AI",
                  minMinutes: "דקות מינ'",
                  maxMinutes: "דקות מקס'"
                },
                columns: {
                  date: "תאריך",
                  customer: "לקוח",
                  agent: "נציג",
                  outcome: "תוצאה",
                  duration: "משך",
                  tags: "תגיות",
                  actions: "פעולות"
                },
                actions: {
                  listen: "האזן להקלטה",
                  download: "הורד הקלטה",
                  transcript: "תמלול",
                  openTicket: "פתח שיחה (לקוח)"
                },
                exportCsv: "ייצוא CSV",
                exportXlsx: "ייצוא Excel",
                exportSelectedCsv: "ייצוא נבחרות CSV",
                exportSelectedXlsx: "ייצוא נבחרות Excel",
                selected: "{{count}} נבחרו",
                empty: "אין שיחות בטווח/פילטר שנבחר",
                transcriptTitle: "תמלול שיחה",
                noTranscript: "אין תמלול זמין"
              },
              agentsPerf: {
                topSales: "מצטיין מכירות",
                topSupport: "מצטיין תמיכה",
                topCollection: "מצטיין גבייה",
                mostActive: "הכי פעיל",
                highestConversion: "שיעור המרה גבוה",
                tableTitle: "ביצועי נציגים",
                agent: "נציג",
                calls: "שיחות",
                answered: "נענו",
                avgDuration: "משך ממוצע",
                conversion: "המרה",
                unassigned: "ללא נציג",
                empty: "אין נתונים בטווח"
              },
              insights: {
                kpis: {
                  conversionRate: "שיעור המרה",
                  followUpRate: "שיעור מעקב",
                  noAnswerRate: "שיעור אין-מענה",
                  complaintRate: "שיעור תלונות",
                  collectionSuccessRate: "הצלחת גבייה",
                  collectionPromiseRate: "הבטחות תשלום"
                },
                heatmapTitle: "מפת חום — שיחות לפי שעה ויום",
                noData: "אין נתונים עדיין",
                topObjections: "התנגדויות נפוצות",
                topActionItems: "משימות נפוצות",
                topIntents: "נושאים מובילים",
                sentiment: "סנטימנט",
                days: {
                  sun: "א'",
                  mon: "ב'",
                  tue: "ג'",
                  wed: "ד'",
                  thu: "ה'",
                  fri: "ו'",
                  sat: "ש'"
                },
                ask: {
                  title: "שאל את ה-AI על השיחות",
                  placeholder: "לדוגמה: על מה לקוחות התלוננו החודש? אילו יעדים מבוקשים?",
                  button: "שאל",
                  noData: "אין מספיק נתוני שיחות כדי לענות"
                }
              },
              collectionTab: {
                filters: {
                  all: "הכל",
                  pending: "ממתין",
                  promised: "הבטחת תשלום",
                  paid: "שולם",
                  overdue: "באיחור"
                },
                columns: {
                  date: "תאריך",
                  customer: "לקוח",
                  agent: "נציג",
                  amountDue: "חוב",
                  amountPromised: "הובטח",
                  dueDate: "תאריך יעד",
                  status: "סטטוס",
                  actions: "פעולות"
                },
                status: {
                  pending: "ממתין",
                  promised: "הובטח",
                  paid: "שולם",
                  failed: "נכשל"
                },
                openTicket: "פתח שיחה",
                empty: "אין שיחות גבייה לפילטר שנבחר"
              },
              branding: {
                title: "מיתוג קולי (Voice Branding)",
                note: "הודעת פתיחה ומוזיקת המתנה ממותגות לשיחות. ההגדרות נשמרות עכשיו; ההשמעה בשיחה עצמה תופעל רק לאחר אימות ה-Live של Phase 1.",
                enable: "הפעל מיתוג קולי",
                welcomeTitle: "הודעת פתיחה",
                welcomeText: "טקסט פתיחה (יוקרא ב-TTS)",
                welcomeTextHint: "אם נבחר גם קובץ — הקובץ קודם",
                welcomeAsset: "קובץ פתיחה (MP3)",
                waitingAsset: "מוזיקת המתנה (MP3)",
                language: "שפה",
                none: "ללא",
                assetsTitle: "קבצי אודיו",
                uploadKind: "סוג",
                upload: "העלה קובץ",
                noAssets: "אין קבצים — העלה MP3 ראשון",
                preview: "השמע",
                delete: "מחק",
                saved: "נשמר",
                uploaded: "הקובץ הועלה",
                previewFailed: "השמעה נכשלה",
                kinds: {
                  welcome: "פתיחה",
                  waiting: "המתנה",
                  announcement: "הכרזה"
                }
              },
              search: {
                placeholder: "חפש בתמלולים, סיכומי AI, זיכרון לקוח והערות…",
                button: "חפש",
                results: "{{count}} תוצאות",
                empty: "לא נמצאו תוצאות — נסה ניסוח אחר",
                loadMore: "טען עוד",
                openTicket: "פתח שיחה",
                scopes: {
                  all: "הכל",
                  transcripts: "תמלולים",
                  analyses: "סיכומי AI",
                  memory: "זיכרון לקוח",
                  notes: "הערות שיחה"
                },
                sources: {
                  transcript: "תמלול",
                  analysis: "ניתוח AI",
                  memory: "זיכרון",
                  notes: "הערות"
                }
              },
              outcomes: {
                sale: "מכירה",
                follow_up: "מעקב",
                support: "תמיכה",
                collection: "גבייה",
                complaint: "תלונה",
                no_answer: "אין מענה",
                wrong_number: "מספר שגוי"
              },
              tabs: {
                overview: "סקירה",
                calls: "שיחות",
                search: "חיפוש",
                agents: "נציגים",
                collection: "גבייה",
                insights: "תובנות"
              },
              range: {
                label: "טווח",
                days7: "7 ימים",
                days30: "30 ימים",
                days90: "90 ימים"
              },
              widgets: {
                totalCalls: "סהכ שיחות",
                totalDuration: "זמן שיחות כולל",
                avgDuration: "משך ממוצע",
                callsToday: "שיחות היום",
                callsThisWeek: "שיחות השבוע",
                callsThisMonth: "שיחות החודש",
                callsAnalyzed: "שיחות שנותחו",
                callsPendingAnalysis: "ממתינות לניתוח",
                collectionCalls: "שיחות גבייה",
                vipCalls: "שיחות VIP",
                followUpRequired: "דורשות מעקב"
              },
              agents: {
                title: "שיחות לפי נציג",
                agent: "נציג",
                calls: "שיחות",
                duration: "זמן כולל",
                avgDuration: "ממוצע",
                unassigned: "ללא נציג",
                empty: "אין שיחות בטווח שנבחר"
              },
              notEnabled: {
                title: "מודול Voice אינו פעיל",
                body: "הפעל את Voice בהגדרות כדי לראות נתוני שיחות, או פנה למנהל המערכת."
              }
            },
            voice: {
              callButton: "חייג ללקוח",
              section: {
                memory: "Customer Memory",
                calls: "שיחות",
                collection: "גבייה",
                timeline: "ציר תקשורת"
              },
              timeline: {
                search: "חפש בתקשורת…"
              },
              wizard: {
                step1: "הסבר",
                step2: "חיבור",
                step3: "סיום",
                introTitle: "מה תקבל עם Voice:",
                credsHint: "הזן את ה-API Key מחשבון ה-Telnyx שלך ואת המספר. Whapiz תקים את כל ההגדרות הטכניות (webhook, אפליקציה) אוטומטית — אתה לא צריך לגעת בשום מסך של Telnyx.",
                connect: "חבר אוטומטית",
                done: "Voice מחובר ומוכן! ",
                back: "חזור",
                next: "המשך",
                finish: "סיום"
              },
              verify: {
                button: "אמת מספר",
                code: "קוד אימות",
                confirm: "אשר",
                resend: "שלח שוב",
                sent: "קוד נשלח ב-SMS",
                devCode: "קוד (בדיקה)",
                verified: "מאומת ✓"
              },
              bar: {
                ringing: "מתקשר",
                inCall: "בשיחה",
                ended: "השיחה הסתיימה",
                recording: "מקליט",
                mute: "השתק",
                hangup: "נתק",
                dismiss: "סגור",
                outcomePrompt: "תוצאת השיחה:"
              },
              outcome: {
                sale: "מכירה",
                followUp: "המשך טיפול",
                support: "תמיכה",
                payment: "תשלום",
                complaint: "תלונה",
                noAnswer: "אין מענה"
              },
              memory: {
                title: "Customer Memory",
                confirmed: "מאושר",
                suggested: "הצעות AI — ממתין לאישור",
                empty: "אין עדיין זיכרון ללקוח זה",
                confirm: "אשר",
                dismiss: "דחה",
                edit: "ערוך",
                delete: "מחק",
                add: "הוסף זיכרון",
                source: "מקור",
                fromCall: "מתוך שיחה",
                types: {
                  fact: "עובדה",
                  preference: "העדפה",
                  risk: "סיכון",
                  commitment: "התחייבות"
                }
              },
              calls: {
                title: "שיחות",
                empty: "אין עדיין שיחות",
                listen: "האזן",
                transcript: "תמלול",
                analyze: "נתח שיחה",
                duration: "משך",
                outcome: "תוצאה",
                agent: "נציג",
                analyzing: "מנתח…",
                transcribing: "מתמלל… נסה שוב בעוד רגע",
                noTranscript: "אין תמלול זמין"
              },
              analysis: {
                title: "ניתוח שיחה",
                summary: "סיכום",
                intent: "כוונה",
                sentiment: "סנטימנט",
                objections: "התנגדויות",
                actionItems: "משימות המשך",
                suggestedReply: "הודעת המשך מוצעת"
              },
              collection: {
                title: "גבייה",
                empty: "אין רישומי גבייה",
                amountDue: "יתרה",
                reason: "סיבת חיוב",
                script: "תסריט שיחה",
                generateScript: "צור תסריט",
                paymentLink: "שלח קישור תשלום",
                create: "פתח גבייה",
                status: "סטטוס"
              },
              settings: {
                title: "הגדרות Voice",
                outgoing: "אפשר שיחות יוצאות",
                recording: "אפשר הקלטה",
                transcription: "אפשר תמלול",
                aiAnalysis: "אפשר ניתוח AI",
                paymentAssist: "אפשר עוזר גבייה",
                consent: "הכרזת הקלטה (חובה בישראל)",
                save: "שמור",
                myPhone: "מספר הטלפון שלי לשיחות",
                myPhoneHint: "כשתלחץ 'חייג', המערכת תצלצל למספר הזה קודם — תענה, והיא תחבר אותך ללקוח. כך השיחה אמיתית בלי דפדפן/אוזניות."
              },
              connections: {
                title: "חיבורי Voice",
                add: "חבר ספק",
                test: "בדוק חיבור",
                testCall: "שיחת בדיקה",
                delete: "מחק",
                provider: "ספק",
                phoneNumber: "מספר טלפון",
                status: "סטטוס",
                note: "Whapiz לא מספקת מספרים או שירותי תקשורת. אתה מחבר חשבון ספק משלך והחיוב על השיחות נעשה ישירות מול הספק."
              }
            },
            contactDrawer: {
              header: "מידע איש קשר",
              buttons: {
                edit: "ערוך איש קשר"
              },
              extraInfo: "מידע נוסף",
              chatbotNotes: {
                title: "תגובות צ׳אטבוט"
              },
              travelRequest: {
                title: "בקשת נסיעה",
                score: "ניקוד",
                matchedOffers: "הצעות תואמות ({{count}})",
                fields: {
                  destination: "🌍 יעד",
                  country: "🗺️ מדינה",
                  productType: "✈️ סוג",
                  familyComposition: "👨‍👩‍👧 הרכב",
                  adults: "🧑 מבוגרים",
                  children: "👶 ילדים",
                  childrenAges: "🎂 גילאים",
                  checkInDate: "📅 צ׳ק-אין",
                  checkOutDate: "📅 צ׳ק-אאוט",
                  nights: "🌙 לילות",
                  boardBasis: "🍽️ אירוח",
                  budget: "💰 תקציב",
                  currency: "💱 מטבע",
                  preferences: "⭐ העדפות"
                },
                board: {
                  all_inclusive: "הכל כלול",
                  full_board: "פנסיון מלא",
                  half_board: "חצי פנסיון",
                  bed_breakfast: "לינה וארוחת בוקר",
                  room_only: "לינה בלבד"
                },
                product: {
                  flight_hotel: "טיסה + מלון",
                  flight_only: "טיסה בלבד",
                  hotel_only: "מלון בלבד"
                }
              }
            },
            contactNotes: {
              toasts: {
                added: "הערה נוספה בהצלחה!",
                deleted: "הערה נמחקה בהצלחה!"
              },
              confirm: {
                title: "מחק רשומה",
                message: "האם אתה באמת רוצה למחוק את הרשומה הזו?"
              }
            },
            ticketOptionsMenu: {
              schedule: "לוח זמנים",
              scheduleAppointment: "📅 קביעת תור",
              appointmentTriggering: "מפעיל את בוט התורים…",
              appointmentTriggered: "בוט התורים הופעל — הודעת פתיחה נשלחה.",
              delete: "מחיקה",
              transfer: "העברה",
              resetChatbot: "🔄 איפוס צ'אטבוט",
              requestPayment: "💳 בקשת תשלום",
              mergeBackup: "ייבוא היסטוריה",
              downloadConversation: "📥 הורד שיחה",
              downloading: "מוריד...",
              registerAppointment: "הערות לקשר",
              appointmentsModal: {
                title: "הערות לקשר",
                textarea: "הערה",
                placeholder: "הכנס את המידע שברצונך לרשום כאן"
              },
              confirmationModal: {
                title: "מחיקת כרטיס קשר",
                message: "שים לב! כל ההודעות הקשורות לכרטיס יימחקו."
              },
              buttons: {
                delete: "מחק",
                cancel: "ביטול"
              }
            },
            confirmationModal: {
              buttons: {
                confirm: "אישור",
                cancel: "ביטול"
              }
            },
            messageOptionsMenu: {
              delete: "מחיקה",
              edit: "עריכה",
              history: "היסטוריה",
              reply: "תגובה",
              copy: "העתקה",
              copied: "הטקסט הועתק",
              forward: "העברה",
              forwardbutton: "בחר משתמש להעברת ההודעה",
              reactions: "אימוג'ים",
              removeReactions: "הסר אימוג'י",
              confirmationModal: {
                title: "מחיקת הודעה?",
                message: "פעולה זו לא ניתנת לביטול."
              }
            },
            messageHistoryModal: {
              close: "סגור",
              title: "היסטוריית עריכת הודעה"
            },
            scheduleMessageModal: {
              title: "תזמון הודעה",
              messagePreview: "הודעה לשליחה:",
              noMessage: "לא הוזנה הודעה",
              quickSelect: "בחירה מהירה:",
              minutes: "דקות",
              hour: "שעה",
              hours: "שעות",
              tomorrow: "מחר",
              dateTime: "תאריך ושעה",
              sendTo: "תישלח אל:",
              cancel: "ביטול",
              schedule: "תזמן",
              scheduling: "מתזמן...",
              success: "ההודעה תוזמנה בהצלחה!",
              errors: {
                noMessage: "אנא הזן הודעה תחילה",
                noDate: "אנא בחר תאריך ושעה",
                pastDate: "אנא בחר תאריך עתידי"
              }
            },
            teams: {
              title: "ניהול צוותים",
              stats: {
                totalTeams: "סה״כ צוותים",
                totalMembers: "סה״כ חברים"
              },
              empty: {
                title: "אין צוותים עדיין",
                description: "צור את הצוות הראשון שלך לארגון הסוכנים"
              },
              table: {
                name: "שם הצוות",
                description: "תיאור",
                members: "חברים",
                actions: "פעולות"
              },
              buttons: {
                new: "צוות חדש",
                createFirst: "צור צוות ראשון",
                cancel: "ביטול",
                create: "צור",
                save: "שמור"
              },
              membersCount: "חברים",
              noMembers: "אין חברים",
              dialog: {
                newTitle: "צוות חדש",
                editTitle: "ערוך צוות"
              },
              form: {
                name: "שם הצוות",
                description: "תיאור",
                members: "חברי הצוות",
                searchUsers: "חפש משתמשים...",
                noUsersFound: "לא נמצאו משתמשים",
                tryDifferentSearch: "נסה חיפוש אחר"
              },
              actions: {
                edit: "ערוך",
                delete: "מחק"
              },
              deleteConfirm: {
                title: "מחק צוות",
                message: "האם אתה בטוח שברצונך למחוק צוות זה?"
              },
              messages: {
                created: "הצוות נוצר בהצלחה",
                updated: "הצוות עודכן בהצלחה",
                deleted: "הצוות נמחק בהצלחה"
              },
              errors: {
                loadFailed: "טעינת הצוותים נכשלה",
                saveFailed: "שמירת הצוות נכשלה",
                deleteFailed: "מחיקת הצוות נכשלה",
                nameRequired: "שם הצוות נדרש"
              }
            },
            contactProfile: {
              title: "אינטליגנציה לקוח",
              emptyState: "הפרופיל ייבנה אוטומטית מהשיחה",
              confidence: "ביטחון",
              updated: "עודכן",
              profileNotBuilt: "הפרופיל עדיין לא נבנה",
              sections: {
                personal: "פרטים אישיים",
                travel: "תחומי נסיעה",
                family: "משפחה",
                preferences: "העדפות"
              },
              labels: {
                name: "שם",
                language: "שפה",
                country: "מדינה",
                destinations: "יעדים",
                months: "חודשים",
                duration: "משך",
                budget: "תקציב",
                accommodation: "לינה",
                adults: "מבוגרים",
                children: "ילדים",
                ages: "גילאים",
                requirements: "דרישות",
                interest: "עניין",
                style: "סגנון",
                activities: "פעילויות"
              },
              fields: {
                customerName: "שם הלקוח",
                destination: "יעד",
                travelDates: "תאריכי נסיעה/חודשים",
                adultsCount: "מספר מבוגרים",
                childrenAges: "גילאי ילדים"
              },
              readyToBook: {
                title: "מוכן להזמנה",
                statusReady: "מוכן",
                statusAlmost: "כמעט",
                statusMissing: "חסר מידע",
                noProfile: "אין פרופיל",
                noProfileDesc: "נדרש פרופיל לקוח לפני יצירת סיכום הזמנה. הפרופיל נבנה אוטומטית כאשר הבינה המלאכותית מחלצת מידע מהשיחה.",
                missingInfo: "מידע חסר",
                generating: "מייצר...",
                generateSummary: "צור סיכום הזמנה",
                tryGenerate: "נסה ליצור בכל זאת",
                copyToClipboard: "העתק ללוח",
                statusReadyFull: "מוכן להזמנה",
                statusAlmostFull: "כמעט מוכן",
                statusMoreInfo: "נדרש מידע נוסף"
              },
              toasts: {
                ticketRequired: "נדרש מזהה כרטיס ליצירת סיכום",
                generateFailed: "יצירת סיכום ההזמנה נכשלה",
                copied: "הסיכום הועתק ללוח"
              }
            },
            backendErrors: {
              ERR_VOICE_DIAL_FAILED: "לא ניתן היה לבצע את השיחה. ודאו ששיחות למדינת היעד מאושרות בחשבון.",
              ERR_META_MEDIA_UNSUPPORTED: "שליחת קבצים אינה נתמכת עדיין בערוץ זה.",
              ERR_MEDIA_TOO_LARGE: "הקובץ גדול מדי לשליחה בערוץ זה (מקסימום 20 MB).",
              ERR_META_SEND_FAILED: "לא ניתן לשלוח את ההודעה בערוץ זה — נסה שוב.",
              ERR_META_TOKEN_INVALID: "החיבור לערוץ פג — חבר אותו מחדש בהגדרות.",
              ERR_FACEBOOK_WINDOW_EXPIRED: "חלון התגובה של 24 שעות נסגר; הלקוח צריך לשלוח הודעה חדשה.",
              ERR_META_COMMENT_REPLY_NOT_PERMITTED: "פייסבוק אינו מתיר תגובה פרטית לתגובה על פוסט (נדרש אישור הרשאות). כדי להשיב, הלקוח צריך לפתוח שיחה במסנג'ר.",
              ERR_EDIT_NOT_SUPPORTED_FOR_CHANNEL: "עריכת הודעות אינה נתמכת בערוץ זה.",
              ERR_DELETE_NOT_SUPPORTED_FOR_CHANNEL: "מחיקת הודעות אינה נתמכת בערוץ זה.",
              ERR_CANNOT_FORWARD_TO_OMNICHANNEL: "העברת הודעות לערוץ זה אינה נתמכת.",
              ERR_CANNOT_FORWARD_FROM_OMNICHANNEL: "העברת הודעות מערוץ זה אינה נתמכת.",
              ERR_MESSAGE_BODY_REQUIRED: "נדרש טקסט הודעה.",
              ERR_NO_OTHER_WHATSAPP: "חייב להיות לפחות WhatsApp אחד שהוא ברירת המחדל.",
              ERR_NO_DEF_WAPP_FOUND: "לא נמצא WhatsApp ברירת המחדל. בדוק את עמוד החיבורים.",
              ERR_WAPP_NOT_INITIALIZED: "ההפעלה של WhatsApp הזו לא הופעלה. בדוק את עמוד החיבורים.",
              ERR_WAPP_CHECK_CONTACT: "לא ניתן לבדוק את איש קשר ה-WhatsApp. בדוק את עמוד החיבורים.",
              ERR_WAPP_INVALID_CONTACT: "זה לא מספר WhatsApp חוקי.",
              ERR_WAPP_DOWNLOAD_MEDIA: "לא ניתן להוריד מדיה מ-WhatsApp. בדוק את עמוד החיבורים.",
              ERR_INVALID_CREDENTIALS: "שגיאת אימות. נסה שוב.",
              ERR_SENDING_WAPP_MSG: "שגיאה בשליחת הודעת WhatsApp. בדוק את עמוד החיבורים.",
              ERR_DELETE_WAPP_MSG: "לא ניתן למחוק הודעת WhatsApp.",
              ERR_EDITING_WAPP_MSG: "לא ניתן לערוך הודעת WhatsApp.",
              ERR_OTHER_OPEN_TICKET: "כבר קיים כרטיס פתוח עבור איש הקשר הזה.",
              ERR_SESSION_EXPIRED: "ההפעלה פג תוקפה. אנא התחבר מחדש.",
              ERR_USER_CREATION_DISABLED: "יצירת משתמש נוטרלה על ידי המנהל.",
              ERR_NO_PERMISSION: "אין לך הרשאה לגשת למשאב זה.",
              ERR_DUPLICATED_CONTACT: "איש הקשר עם מספר זה כבר קיים.",
              ERR_NO_SETTING_FOUND: "לא נמצאה הגדרה עם המזהה הזה.",
              ERR_NO_CONTACT_FOUND: "לא נמצא איש קשר עם המזהה הזה.",
              ERR_NO_TICKET_FOUND: "לא נמצא כרטיס עם המזהה הזה.",
              ERR_NO_USER_FOUND: "לא נמצא משתמש עם המזהה הזה.",
              ERR_NO_WAPP_FOUND: "לא נמצא WhatsApp עם המזהה הזה.",
              ERR_CREATING_MESSAGE: "שגיאה ביצירת הודעה במסד הנתונים.",
              ERR_CREATING_TICKET: "שגיאה ביצירת כרטיס במסד הנתונים.",
              ERR_FETCH_WAPP_MSG: "שגיאה באחזור הודעה מ-WhatsApp, אולי היא ישנה מדי.",
              ERR_QUEUE_COLOR_ALREADY_EXISTS: "הצבע הזה כבר בשימוש, בחר צבע אחר.",
              ERR_WAPP_GREETING_REQUIRED: "הודעת הברכה חובה כאשר קיימת יותר מתור אחד."
            },
            aiWizard: {
              title: "הגדרת AI",
              subtitle: "הגדר את העוזר החכם שלך בכמה צעדים פשוטים",
              steps: {
                companyInfo: "פרטי חברה",
                aiAgent: "סוכן AI",
                dataSources: "מקורות מידע",
                externalCrm: "CRM חיצוני",
                handoffRules: "כללי העברה",
                greeting: "ברכה"
              },
              next: "הבא",
              back: "חזרה",
              finishSave: "סיום ושמירה",
              savedSuccess: "הגדרות AI נשמרו בהצלחה!",
              saveFailed: "שמירת ההגדרות נכשלה",
              companyStep: {
                companyName: "שם חברה",
                companyNamePlaceholder: "למשל: סוכנות הנסיעות שלי",
                timezone: "אזור זמן",
                responseLanguage: "שפת תגובה",
                timezones: {
                  israel: "ישראל (Asia/Jerusalem)",
                  uk: "בריטניה (Europe/London)",
                  usEast: "ארה\"ב מזרח (America/New_York)",
                  ukraine: "אוקראינה (Europe/Kiev)"
                },
                languages: {
                  hebrew: "עברית (עברית)",
                  english: "אנגלית",
                  russian: "רוסית (Русский)",
                  arabic: "ערבית (العربية)"
                }
              },
              aiStep: {
                describeCompany: "תאר את החברה שלך והתנהגות ה-AI",
                describePlaceholder: "למשל: אנחנו סוכנות נסיעות המתמחה בחופשות משפחתיות. ה-AI צריך להיות מועיל, להציע יעדים ולאסוף העדפות לקוחות...",
                tone: "טון תקשורת",
                model: "מודל AI",
                tones: {
                  professional: "מקצועי",
                  friendly: "ידידותי",
                  formal: "רשמי"
                },
                models: {
                  gpt4o: "GPT-4o (איכות מעולה)",
                  gpt4oMini: "GPT-4o Mini (מהיר וזול יותר)"
                }
              },
              dataStep: {
                description: "חבר ממשקי API חיצוניים כדי שה-AI יוכל לשלוף מידע אמיתי (מוצרים, מלאי, מחירים) בזמן שיחות. זה אופציונלי.",
                summaryTemplate: "תבנית תצוגת סיכום",
                summaryPlaceholder: "איך להציג נתונים שנאספו לפני תוצאות. השתמש ב-{{fields}} כמציין מקום.",
                dataSourceNum: "מקור מידע #{{num}}",
                name: "שם",
                namePlaceholder: "למשל: קטלוג מוצרים",
                apiUrl: "כתובת API",
                apiUrlPlaceholder: "https://api.mycompany.com/products",
                description2: "תיאור (עבור AI)",
                descriptionPlaceholder: "חיפוש מוצרים לפי קריטריונים של הלקוח",
                requiredFields: "שדות חובה (מופרדים בפסיקים)",
                requiredFieldsPlaceholder: "למשל: קטגוריה, תקציב, גודל, סגנון מועדף",
                requiredFieldsHelper: "ה-AI יאסוף שדות אלו אחד אחד לפני החיפוש",
                addDataSource: "הוסף מקור מידע"
              },
              crmStep: {
                description: "ניתן לחבר CRM חיצוני (Supabase) למילוי אוטומטי של פרטי לקוחות מהמאגר. ניתן לדלג על שלב זה.",
                enable: "הפעל CRM חיצוני",
                supabaseUrl: "כתובת Supabase",
                supabaseKey: "מפתח API של Supabase",
                testConnection: "בדוק חיבור",
                tableName: "טבלת חיפוש",
                phoneField: "עמודת טלפון",
                nameFields: "עמודות שם",
                nameFieldsHelp: "מופרדים בפסיקים, למשל first_name, last_name",
                detectedFields: "עמודות שזוהו",
                skipNote: "שלב זה אופציונלי. אם אין לך CRM חיצוני, לחץ על הבא."
              },
              handoffStep: {
                description: "הגדר מתי ה-AI צריך להעביר את השיחה לנציג אנושי.",
                customPlaceholder: "תאר תנאי העברה מותאם...",
                addCustomRule: "הוסף כלל מותאם",
                triggers: {
                  pricing: "לקוח שואל על מחירים",
                  complaint: "תלונת לקוח",
                  humanRequest: "לקוח מבקש נציג אנושי",
                  aiFailure: "AI לא יכול לענות"
                }
              },
              greetingStep: {
                enableGreeting: "הפעל ברכה אוטומטית",
                greetingMessage: "הודעת ברכה",
                greetingPlaceholder: "למשל: שלום! ברוכים הבאים לחנות שלנו. איך אוכל לעזור לך היום?"
              }
            },
            tour: {
              buttons: {
                back: "חזרה",
                close: "סגור",
                last: "סיום",
                next: "הבא",
                skip: "דלג על הסיור"
              },
              welcome: {
                title: "ברוכים הבאים ל־Whapiz! 👋",
                content: "בוא נגדיר את העסק שלך ב־4 שלבים פשוטים. זה לוקח כ־5 דקות."
              },
              connections: {
                title: "שלב 1 — חבר את מספר הוואטסאפ שלך",
                content: "לחץ כאן כדי לפתוח את עמוד החיבורים, שם תוסיף את מספר WhatsApp Business API שלך.",
                contentMobile: "הקש על תפריט ☰ למעלה משמאל, ובחר 'חיבורים'. שם מחברים את מספר WhatsApp Business API."
              },
              metaButton: {
                title: "לחץ על 'חבר WhatsApp Business API'",
                content: "הצוות שלך יספק לך 3 ערכים מ־Meta Business Manager: Phone Number ID, WABA ID ו־API Token. הדבק אותם בשלב 2 של האשף וזהו."
              },
              queues: {
                title: "שלב 2 — צור תור ראשון",
                content: "תורים מארגנים שיחות נכנסות לפי מחלקה או נושא (מכירות, תמיכה, חיובים…). לחץ כאן ואז '+הוסף' כדי ליצור תור ראשון.",
                contentMobile: "הקש על תפריט ☰, ואז 'תורים'. תורים מארגנים שיחות נכנסות לפי מחלקה (מכירות, תמיכה, חיובים…). הקש על '+הוסף' כדי ליצור תור ראשון."
              },
              botChoice: {
                title: "שלב 3 — בחר איך הבוט יענה",
                content: "יש לך שתי אפשרויות:\n\n📋 בוט תפריט פשוט — לקוחות רואים תפריט ממוספר (1 - מכירות, 2 - תמיכה…). קל להגדיר בתוך כל תור ← לשונית אפשרויות.\n\n🤖 עוזר AI — GPT-4 עונה בשפה טבעית. מתאים למכירות ולשאלות מורכבות. השלב הבא פותח את אשף ההגדרה של ה־AI.\n\nאפשר לדלג כעת ולהחליט מאוחר יותר."
              },
              aiSettings: {
                title: "עוזר AI (אופציונלי)",
                content: "מלא את 6 השלבים הקצרים כדי ללמד את ה־AI על העסק שלך: פרטי החברה, טון הדיבור, מקורות ידע, אינטגרציית CRM, מתי להעביר לאדם אנושי, וההודעת פתיחה. ה־AI משתמש ב־GPT-4 ועונה בשפת הלקוח. דלג על שלב זה אם אתה מעדיף בוט תפריט פשוט."
              },
              users: {
                title: "שלב 4 — הזמן את הצוות שלך",
                content: "הוסף את הנציגים שיטפלו בשיחות לקוחות. לכל נציג יש כניסה ותיבה משלו.",
                contentMobile: "הקש על תפריט ☰, ואז 'משתמשים'. הוסף את הנציגים שיטפלו בשיחות לקוחות — לכל נציג יש כניסה ותיבה משלו."
              },
              done: {
                title: "🎉 הכל מוכן!",
                content: "הלקוחות שלך יכולים כעת להתחיל לשלוח הודעות, והצוות יכול לענות מכאן. אפשר להפעיל מחדש את הסיור מתוך תפריט הפרופיל."
              }
            },
            setupAssistant: {
              title: "עוזר הגדרת AI",
              subtitle: "תאר את העסק שלך — אגדיר את הבוט",
              welcomeTitle: "איך אני יכול לעזור לך?",
              welcomeText: "תאר את העסק שלך או בחר התחלה מהירה:",
              welcomeQuestions: "שלום! אני אעזור לך להגדיר את הבוט שלך בוואטסאפ. בוא נתחיל עם כמה שאלות:\n\n1. **מצב בוט** — מה אתה מעדיף?\n• **צ'אטבוט** — תפריט עם קטגוריות, שאלות מובנות\n• **AI ישיר** — שיחה חופשית, בלי תפריטים\n\n2. **קטגוריות** — על מה הלקוחות שלך פונים? (למשל: תקלות, תשלומים, פגישות...)\n\n3. **CRM** — יש לך מערכת ניהול לקוחות שתרצה לחבר?\n\nענה ונבנה את הבוט שלך צעד אחר צעד!",
              inputPlaceholder: "תאר את העסק שלך...",
              error: "מצטער, משהו השתבש. נסה שוב.",
              applied: "ההגדרות הוחלו! בדוק את השדות ולחץ שמור.",
              configReady: "הגדרה מוכנה",
              applyConfig: "החל הגדרה",
              restart: "התחל מחדש",
              suggestions: {
                building: "חברת ניהול מבנים",
                clinic: "מרפאה רפואית",
                restaurant: "מסעדה / משלוחי אוכל",
                cleaning: "שירותי ניקיון",
                law: "משרד עורכי דין"
              },
              config: {
                company: "חברה",
                mode: "מצב בוט",
                language: "שפה",
                tone: "טון",
                queues: "תורים",
                greeting: "ברכה",
                tasks: "משימות אוטומטיות",
                crm: "אינטגרציית CRM"
              }
            },
            subscriptionsManager: {
              title: "מנויי חברות",
              subtitle: "ניהול הקצאות תוכניות וחיוב עבור כל הלקוחות",
              loadFailed: "טעינת מנויים נכשלה",
              assignPlan: "הקצה תוכנית",
              assignSuccess: "התוכנית הוקצתה בהצלחה",
              assignFailed: "הקצאת התוכנית נכשלה",
              cancelConfirm: "האם אתה בטוח שברצונך לבטל מנוי זה?",
              cancelSuccess: "המנוי בוטל",
              cancelFailed: "ביטול המנוי נכשל",
              recordPayment: "רשום תשלום",
              paymentSuccess: "התשלום נרשם בהצלחה",
              paymentFailed: "רישום התשלום נכשל",
              refresh: "רענן",
              cancel: "ביטול",
              noSubscriptions: "אין מנויים עדיין. הקצה תוכניות לחברות כדי להתחיל.",
              emptyDescription: "אין מנויים עדיין. דיירים יופיעו כאן לאחר הפעלת תוכנית.",
              table: {
                company: "חברה",
                plan: "תוכנית",
                status: "סטטוס",
                period: "תקופת חיוב",
                 autoRenew: "חידוש אוטומטי",
                actions: "פעולות"
              },
              form: {
                companyId: "מזהה חברה",
                plan: "תוכנית",
                status: "סטטוס",
                periodMonths: "תקופה (חודשים)",
                amount: "סכום",
                currency: "מטבע",
                description: "תיאור",
                type: "סוג תשלום",
                cancel: "ביטול",
                assign: "הקצה",
                record: "רשום תשלום"
              }
            },
            billingPage: {
    paymentVerifying: "מאמתים את התשלום…",
    paymentVerifyingDesc: "נא להמתין בזמן שאנחנו מאשרים את העסקה מול ספק התשלומים.",
    paymentSuccessNoRef: "חסר מזהה תשלום",
    paymentSuccessNoRefDesc: "לא נמצא מזהה עסקה לאימות. בדקו את עמוד החיוב.",
    paymentPendingTitle: "התשלום עדיין בעיבוד",
    paymentPendingSubtitle: "עדיין לא קיבלנו אישור סופי. זה עשוי לקחת רגע.",
    paymentCheckAgain: "בדוק שוב",
    paymentNotFoundTitle: "העסקה לא נמצאה",
    paymentNotFoundSubtitle: "לא הצלחנו למצוא את העסקה. אם חויבתם, פנו לתמיכה.",
    paymentFailedTitle: "התשלום לא עבר",
    paymentFailedSubtitle: "העסקה לא הושלמה. לא חויבתם.",
    paymentSupportLine: "צריכים עזרה? כתבו לנו ל-{{email}}.",
    backToBilling: "חזרה לחיוב",
    backToDashboard: "חזרה ללוח הבקרה",
    viewInvoices: "צפייה בחשבוניות",
    psPlan: "תוכנית",
    psBillingPeriod: "תקופת חיוב",
    psReference: "מזהה עסקה",
    psDate: "תאריך",
    psCard: "כרטיס",
    psStarts: "תחילת המנוי",
    psNextCharge: "חיוב הבא",
    psAutoRenew: "חידוש אוטומטי",
    psAutoRenewOff: "חידוש אוטומטי כבוי",
    psAmount: "סכום שחויב",
    psInvoiceSent: "חשבונית נשלחה אל {{email}}.",
    psInvoiceNote: "החשבונית זמינה בעמוד החיוב.",
    interval_monthly: "חודשי",
    interval_yearly: "שנתי",
    on: "פעיל",
    off: "כבוי",

              paymentSuccessTitle: "התשלום בוצע בהצלחה",
              paymentSuccessSubtitle: "המנוי שלך פעיל כעת",
              paymentSuccessPlanLabel: "תוכנית",
              paymentSuccessNext: "חשבונית נשלחה לכתובת המייל שלך. אפשר לנהל את המנוי בכל עת למטה.",
              paymentSuccessCta: "סיום",
              cancelSubscription: "ביטול מנוי",
              resumeAutoRenew: "חידוש אוטומטי",
              cancelConfirmTitle: "לבטל חידוש אוטומטי?",
              cancelConfirmBody: "המנוי יישאר פעיל עד {{date}}, ולאחר מכן לא יתחדש. אפשר להפעיל מחדש בכל עת.",
              cancelConfirmKeep: "להשאיר מנוי",
              cancelConfirmYes: "ביטול מנוי",
              title: "חיוב ומנוי",
              subtitle: "נהל את תוכנית המנוי, היסטוריית תשלומים וחשבוניות",
              loadFailed: "טעינת נתוני חיוב נכשלה",
              tabs: {
                overview: "סקירת תוכנית",
                payments: "היסטוריית תשלומים",
                invoices: "חשבוניות וקבלות"
              },
              currentPlan: "תוכנית נוכחית",
              noPlan: "לא הוקצתה תוכנית",
              noPlanDesc: "צור קשר עם מנהל המערכת להקצאת תוכנית מנוי.",
              noSubscription: "אין מנוי פעיל. התוכנית שלך הוקצתה אך החיוב טרם החל.",
              perMonth: "חודש",
              perYear: "שנה",
              trialBilling: "תקופת ניסיון",
              periodStart: "תחילת תקופה",
              periodEnd: "סוף תקופה",
              trialEnds: "ניסיון מסתיים",
              features: {
                users: "משתמשים",
                connections: "חיבורי WhatsApp",
                queues: "תורים",
                ai: "סוכן AI כלול",
                crm: "אינטגרציית CRM"
              },
              paymentHistory: "היסטוריית תשלומים",
              noPayments: "אין תשלומים עדיין. היסטוריית התשלומים תופיע כאן.",
              invoiceHistory: "חשבוניות וקבלות",
              noInvoices: "אין חשבוניות עדיין. החשבוניות יופיעו כאן לאחר תשלומים.",
              downloadInvoice: "הורד חשבונית",
              payNow: "שלם עכשיו",
              renewSubscription: "חידוש מנוי",
              renewDesc: "המשך את התוכנית שלך ושמור על גישה רציפה.",
              renewLoading: "מעבד...",
              renewFailed: "החידוש נכשל. נסה שוב.",
              paymentSuccess: "התשלום בוצע בהצלחה",
              paymentFailed: "התשלום נכשל",
              pastDueBanner: "המנוי שלך באיחור. שלם כדי לשחזר גישה.",
              trialBanner: "תקופת הניסיון פעילה. שדרג בכל עת כדי לשמור על גישה.",
              noTerminal: "טרמינל תשלום לא מוגדר. צור קשר עם התמיכה.",
              table: {
                date: "תאריך",
                description: "תיאור",
                amount: "סכום",
                status: "סטטוס",
                method: "אמצעי תשלום",
                invoice: "חשבונית #",
                actions: "פעולות"
              }
            },
            requestPaymentDialog: {
              title: "בקשת תשלום",
              confirmTitle: "אשר בקשת תשלום",
              recipient: "נמען",
              unnamedContact: "איש קשר זה",
              amountLabel: "סכום",
              currencyLabel: "מטבע",
              descriptionLabel: "תיאור",
              descriptionHelp: "מוצג ללקוח בעמוד טרנזילה. עד 80 תווים.",
              confirmBody: "שלח קישור תשלום עבור",
              confirmTo: "אל",
              confirmHelp: "הקישור יישלח כהודעת וואטסאפ בשיחה הזו.",
              invalidAmount: "הזן סכום של לפחות 0.01.",
              invalidDescription: "הזן תיאור קצר (עד 80 תווים).",
              sentSuccess: "קישור התשלום נשלח ללקוח.",
              sendFailed: "שליחת קישור התשלום נכשלה. נסה שוב.",
              noTerminal: "לא הוגדר טרמינל טרנזילה לחברה שלך.",
              openSettings: "פתח הגדרות ← תשלומים",
              cancel: "ביטול",
              next: "המשך",
              sendNow: "שלח קישור תשלום"
            },
            aiWorkforcePage: {
              title: "AI Workforce",
              subtitle: "ניהול מנוע ה-AI — סוכנים, כללים, יומנים ומתג ראשי.",
              notForTenant: {
                title: "לא זמין עבור דייר זה",
                help: "לוח AI Workforce משמש רק את צינור GoDeal. דיירים גנריים מגדירים AI מדף הגדרות AI."
              },
              toggle: {
                title: "מתג ראשי — AI Workforce",
                description: "כשכבוי, כל צינור סוכן ה-AI עוקף לחלוטין.",
                enabled: "AI Workforce הופעל ✅",
                disabled: "AI Workforce כובה",
                failed: "שגיאה בהפעלת/כיבוי AI Workforce"
              },
              tabs: {
                stats: "סטטיסטיקה",
                rules: "כללים",
                logs: "יומני פעולות",
                agents: "סוכנים"
              },
              stats: {
                totalAgents: "סוכנים",
                activeAgents: "פעילים",
                totalRules: "כללים",
                totalKnowledge: "ידע",
                actionsToday: "פעולות היום",
                actionsWeek: "פעולות השבוע",
                escalationsToday: "הסלמות היום",
                successRate: "שיעור הצלחה",
                pipelineHealth: "מצב הצינור",
                healthy: "תקין",
                warning: "אזהרה",
                critical: "בעיה",
                autoRefresh: "מתרענן אוטומטית"
              },
              rules: {
                empty: "לא הוגדרו כללים עדיין.",
                newRule: "כלל חדש",
                editRule: "עריכת כלל",
                edit: "ערוך כלל",
                delete: "מחק כלל",
                deleted: "הכלל נמחק",
                created: "הכלל נוצר",
                updated: "הכלל עודכן",
                deleteFailed: "מחיקת הכלל נכשלה",
                updateFailed: "עדכון הכלל נכשל",
                confirmDelete: "למחוק את הכלל \"{{name}}\"? לא ניתן לבטל פעולה זו.",
                col: {
                  name: "שם",
                  type: "סוג",
                  priority: "עדיפות",
                  active: "פעיל",
                  actions: "פעולות"
                },
                types: {
                  pricing: "תמחור",
                  commission: "עמלה",
                  escalation: "הסלמה",
                  handoff: "העברה לנציג",
                  response_template: "תבנית תגובה"
                },
                form: {
                  name: "שם הכלל",
                  type: "סוג הכלל",
                  priority: "עדיפות",
                  active: "פעיל",
                  description: "תיאור (אופציונלי)",
                  conditions: "תנאים (JSON)",
                  actions: "פעולות (JSON)",
                  jsonHelp: "הסכמה תלויה במנוע. לשימוש מתקדם בלבד.",
                  advancedMode: "מצב מתקדם (JSON)",
                  save: "שמור",
                  cancel: "ביטול",
                  saveFailed: "שמירת הכלל נכשלה",
                  invalidJson: "JSON לא תקין",
                  nameTypeRequired: "שם וסוג הם שדות חובה",
                  productTypes: "סוגי מוצרים",
                  priceFrom: "מחיר מינימום (₪)",
                  priceTo: "מחיר מקסימום (₪)",
                  boardTypes: "סוגי בסיס",
                  triggerKeywords: "מילות מפתח (מופרדות בפסיק)",
                  confidenceThreshold: "סף ביטחון (0-100)",
                  commissionRate: "שיעור עמלה (%)",
                  markupRate: "שיעור תוספת (%)",
                  escalateTrigger: "טריגר הסלמה",
                  handoffMessage: "הודעת העברה",
                  responseTemplate: "תבנית תגובה"
                }
              },
              logs: {
                empty: "אין יומני פעולות עדיין.",
                filterByStatus: "סנן לפי סטטוס",
                allStatuses: "הכל",
                searchAction: "חפש פעולה...",
                expandDetails: "פרטים",
                inputData: "נתוני קלט",
                outputData: "נתוני פלט",
                col: {
                  when: "מתי",
                  action: "פעולה",
                  agent: "סוכן",
                  ticket: "כרטיס",
                  status: "סטטוס",
                  latency: "השהיה",
                  error: "שגיאה"
                }
              },
              agents: {
                title: "סוכני AI פעילים",
                noAgents: "לא נמצאו סוכנים.",
                roles: {
                  offer_matcher: "מחפש הצעות",
                  pricing_calculator: "מחשב מחירים",
                  conversation: "סוכן שיחה",
                  supervisor: "מפקח",
                  queue_manager: "מנהל תור",
                  notification_engine: "מנוע התראות",
                  business_intelligence: "ניתוח עסקי",
                  appointment_scheduler: "תיאום פגישות"
                },
                calendarConnected: "יומן מחובר ✓",
                secretaryName: "מזכירה AI — תיאום פגישות",
                secretarySubtitle: "מחובר ליומן — פגישות בשיחה טבעית"
              },
              refresh: "רענן"
            },
            aiSettingsPage: {
              title: "הגדרות AI",
              subtitle: "הגדר את התנהגות העוזר החכם שלך",
              goToAIWorkforce: "עבור ל-AI Workforce",
              aiWorkforce: {
                title: "AI Workforce",
                description: "הפעל או כבה את כל עיבוד ה-AI עבור חברה זו",
                enabled: "AI Workforce הופעל",
                disabled: "AI Workforce כובה",
                toggleFailed: "שגיאה בהפעלת/כיבוי AI Workforce"
              },
              saveChanges: "שמור שינויים",
              saving: "שומר...",
              settingsSaved: "ההגדרות נשמרו!",
              failedToLoad: "טעינת הגדרות AI נכשלה",
              failedToSave: "שמירת ההגדרות נכשלה",
              companyInfo: {
                title: "פרטי חברה",
                companyName: "שם חברה",
                companyNameHelp: "שם התצוגה של החברה שלך. מופיע בהודעות ובברכות ללקוחות.",
                timezone: "אזור זמן",
                timezoneHelp: "הגדר את אזור הזמן המקומי. משפיע על הודעות מתוזמנות, מעקב ושעות פעילות.",
                language: "שפה",
                languageHelp: "השפה הראשית שבה הבוט ידבר עם הלקוחות.",
                timezones: {
                  israel: "ישראל",
                  uk: "בריטניה",
                  usEast: "ארה\"ב מזרח",
                  ukraine: "אוקראינה"
                },
                languages: {
                  hebrew: "עברית",
                  english: "אנגלית",
                  russian: "רוסית",
                  arabic: "ערבית"
                }
              },
              aiBehavior: {
                title: "התנהגות AI",
                titleHelp: "שלוט כיצד הAI מגיב ללקוחות — האישיות שלו, בסיס הידע והיכולות.",
                systemPrompt: "הנחיות מערכת",
                systemPromptHelp: "הנחיות מותאמות ל-AI. תאר מה הAI צריך לדעת, איך להתנהג, ומה לעולם לא לעשות. זו ההגדרה החשובה ביותר לשליטה בהתנהגות הAI.",
                tone: "טון",
                toneHelp: "סגנון השיחה של הAI. מקצועי = עסקי, ידידותי = חם ונינוח, רשמי = מנומס ומדויק.",
                model: "מודל",
                modelHelp: "מודל הAI לשימוש. GPT-5 הכי מסוגל אך איטי/יקר יותר. GPT-4o Mini מהיר ומשתלם למשימות פשוטות.",
                aiEnabled: "סוכן AI מופעל",
                tones: {
                  professional: "מקצועי",
                  friendly: "ידידותי",
                  formal: "רשמי"
                }
              },
              dataSources: {
                title: "מקורות מידע",
                description: "ממשקי API חיצוניים שה-AI יכול להשתמש בהם כדי לשלוף מידע בזמן אמת.",
                sourceType: "סוג מקור מידע",
                sourceTypeHelp: "איך הAI ניגש לקטלוג המוצרים/השירותים שלך. REST API = נקודת קצה מותאמת. Supabase = שאילתת מסד נתונים ישירה. ללא = בלי חיפוש קטלוג.",
                none: "ללא",
                restApi: "REST API",
                supabase: "Supabase",
                supabaseUrl: "כתובת Supabase",
                supabaseApiKey: "מפתח API של Supabase",
                summaryTemplate: "תבנית תצוגת סיכום",
                summaryHelperText: "איך להציג נתונים שנאספו. השתמש ב-{{fields}} כמציין מקום.",
                toolName: "שם",
                toolNameHelp: "שם תיאורי למקור מידע זה. דוגמה: 'חיפוש חבילות נופש', 'קטלוג מוצרים'.",
                toolApiUrl: "כתובת API",
                toolApiUrlHelp: "הכתובת המלאה של נקודת הקצה. הAI יקרא לכתובת זו כדי לחפש מוצרים/שירותים.",
                toolDescription: "תיאור",
                toolDescriptionHelp: "הסבר מה הAPI הזה עושה בשפה פשוטה. הAI משתמש בזה כדי להחליט מתי לקרוא לו.",
                requiredFields: "שדות חובה (מופרדים בפסיקים)",
                requiredFieldsPlaceholder: "למשל: קטגוריה, תקציב (אופציונלי)",
                requiredFieldsHelp: "שדות שהAI חייב לאסוף מהלקוח לפני קריאה לAPI. השאר ריק לגלישה פשוטה בקטלוג.",
                requiredFieldsHelper: "לשאילתות פשוטות — השאר ריק. הוסף רק לחיפוש מסונן.",
                addDataSource: "הוסף מקור מידע",
                maxProductCardsHelp: "כמה כרטיסי מוצר/שירות להציג בכל חיפוש. פחות = תגובה מהירה, יותר = אפשרויות נוספות ללקוח.",
                filterConfigHelp: "הגדרת JSON מתקדמת שממפה נתוני קליטה מהלקוח לפרמטרי שאילתת API. ערוך רק אם אתה מכיר את מבנה ה-API שלך."
              },
              categoryStructure: {
                title: "מבנה קטגוריות",
                titleHelp: "קטגוריות עוזרות ל-AI לארגן מוצרים/שירותים. כאשר לקוח מבקש משהו, הAI מסנן לפי קטגוריות אלה. ניתן לזהות אוטומטית מהנתונים או להוסיף ידנית.",
                description: "ה-AI משתמש במבנה זה כדי להבין את קטגוריות הנתונים שלך ולסנן פריטים בדיוק. סרוק את מקור הנתונים לזיהוי אוטומטי, או הגדר ידנית.",
                autoDetect: "זיהוי אוטומטי",
                scanning: "סורק...",
                autoDetected: "זוהה אוטומטית",
                manual: "ידני",
                lastScan: "סריקה אחרונה",
                categoryField: "שם שדה קטגוריה",
                categoryFieldHelper: "השדה בנתונים שלך שמכיל את הקטגוריה",
                subcategoryField: "שם שדה תת-קטגוריה",
                subcategoryFieldHelper: "שדה קיבוץ משני אופציונלי",
                items: "פריטים",
                noCategories: "עדיין לא זוהו קטגוריות. לחץ על \"זיהוי אוטומטי\" כדי לסרוק את מקור הנתונים.",
                addManually: "הוסף קטגוריה ידנית",
                editName: "ערוך שם",
                remove: "הסר",
                detected: "זוהו {{count}} קטגוריות",
                detectionFailed: "הזיהוי נכשל",
                failedToScan: "סריקת קטגוריות נכשלה"
              },
              handoffRules: {
                title: "כללי העברה",
                titleHelp: "כללים שקובעים מתי הAI צריך לעצור ולהעביר את השיחה לנציג אנושי. הפעל כללים מובנים או הוסף תנאים מותאמים משלך.",
                addCustomRule: "הוסף כלל מותאם"
              },
              numberProfiles: {
                title: "פרופילי מספרי WhatsApp",
                description: "הגדר התנהגות AI לכל מספר WhatsApp. לכל מספר יכולים להיות מצב בוט, תורי AI ושאלות קליטה משלו.",
                noNumbers: "לא נמצאו מספרי WhatsApp. הוסף חיבור קודם.",
                saveProfile: "שמור פרופיל",
                saved: "הפרופיל נשמר!",
                saveFailed: "שמירת הפרופיל נכשלה",
                modeChatbot: "צ'אטבוט AI (קטגוריות → שאלות → מוצרים)",
                modeDirect: "AI ישיר (שיחה חופשית)",
                modeOff: "כבוי (בוט תפריט קלאסי בלבד)",
                systemPromptOverride: "דריסת פרומפט מערכת",
                systemPromptOverrideHelp: "דרוס את פרומפט המערכת הכללי למספר זה. השאר ריק לשימוש בפרומפט ברירת המחדל.",
                systemPromptPlaceholder: "השאר ריק לשימוש בפרומפט ברירת המחדל של החברה",
                aiQueuesTitle: "תורי בוט AI",
                aiQueuesHelp: "הגדר קטגוריות שירות שהלקוח יכול לבחור מהן. לכל תור יכולות להיות שאלות קליטה, יצירת משימה אוטומטית ותבנית סיכום. דוגמה: 'בקשת שירות', 'חיובים', 'שאלות כלליות'.",
                queueName: "שם תור",
                queueNameHelp: "השם שמוצג ללקוח בתפריט הבחירה. השתמש בשמות ברורים ופשוטים.",
                queueDescription: "תיאור",
                queueDescriptionHelp: "תיאור קצר של מה שהתור הזה מטפל בו. עוזר ל-AI לנתב לקוחות נכון.",
                addQueue: "הוסף תור AI"
              },
              chatbotSettings: {
                title: "הגדרות צ'אטבוט",
                description: "הגדר כיצד הצ'אטבוט מטפל בשיחות נכנסות לפני העברה לנציג.",
                botMode: "מצב בוט",
                botModeHelp: "בחר כיצד הAI מתקשר עם לקוחות. צ'אטבוט AI = תהליך מובנה עם תפריטים ושאלות. AI ישיר = שיחת AI חופשית. כבוי = ללא AI, תפריט קלאסי בלבד.",
                botModeMenu: "בוט תפריט (שלב-אחרי-שלב)",
                botModeAI: "בוט AI (שיחה טבעית)",
                botModeHelper: "בוט תפריט משתמש בתפריטים קבועים. בוט AI מנהל שיחה טבעית לאיסוף מידע.",
                questionsTitle: "שאלות קליטה",
                questionsHelp: "שאלות שהבוט שואל לפני העברה לנציג אנושי. לכל שאלה יש שם שדה (לשימוש פנימי) והטקסט שמוצג ללקוח.",
                questionsDescription: "הגדר את המידע שהAI צריך לאסוף מהלקוח לפני העברה לנציג.",
                addQuestion: "הוסף שאלה",
                questionField: "שם שדה",
                questionFieldHelp: "שם פנימי קצר לנתון. משמש בתבניות ובסנכרון CRM. דוגמה: name, address, description, budget.",
                questionText: "טקסט שאלה",
                questionTextHelp: "השאלה המדויקת שהבוט ישאל את הלקוח. כתוב בשפת הלקוח. דוגמה: 'מה השם שלך?'",
                questionRequired: "חובה",
                questionRequiredHelp: "אם מופעל, הבוט ימשיך לשאול עד שהלקוח יענה. אם כבוי, הלקוח יכול לדלג על שאלה זו.",
                questionOptions: "אפשרויות (מופרדות בפסיק)",
                questionOptionsHelp: "השאר ריק לטקסט חופשי. לדוגמה: אלקטרוניקה, תכשיטים, ביגוד. 1-3 = כפתורים, 4+ = רשימה.",
                noQuestions: "לא הוגדרו שאלות קליטה. הAI ישוחח בחופשיות ללא איסוף נתונים ספציפיים.",
                defaultQueue: "תור ברירת מחדל",
                defaultQueueHelper: "תור להקצאת כרטיסים כשהAI לא יכול לקבוע את התור הנכון",
                noQueue: "ללא תור ברירת מחדל",
                autoCreateTask: "יצירת משימה אוטומטית לאחר קליטה",
                autoCreateTaskHelp: "כאשר מופעל, נוצרת משימה אוטומטית במערכת לאחר שהלקוח משלים את כל שאלות הקליטה. שימושי לבקשות שירות.",
                summaryTemplate: "תבנית סיכום",
                summaryTemplateHelp: "הודעת האישור שנשלחת ללקוח לאחר השלמת טופס הקליטה. השתמש ב-{{field}} להוספת נתונים שנאספו.",
                summaryTemplatePlaceholder: "לדוגמה: *הבקשה התקבלה!*\nשם: {{name}}\nכתובת: {{address}}",
                summaryTemplateHelper: "השתמש ב-{{field}} כמציינים. השאר ריק לשימוש בברירת המחדל של החברה."
              },
              greeting: {
                title: "ברכה",
                titleHelp: "הודעת הברכה נשלחת אוטומטית כאשר לקוח שולח הודעה לראשונה או לאחר תקופה ארוכה של חוסר פעילות.",
                enableGreeting: "הפעל ברכה אוטומטית",
                greetingMessage: "הודעת ברכה",
                greetingMessageHelp: "ההודעה הראשונה שהלקוח רואה. כלול ברכה, שם החברה, ובמה הבוט יכול לעזור."
              },
              sections: {
                general: "הגדרות כלליות",
                generalDesc: "זהות החברה, מודל AI, שפה והגדרות ברכה",
                generalHelp: "הגדרות בסיסיות: שם החברה, שפה מועדפת, מודל AI, והודעת הברכה שהלקוחות רואים ראשונה.",
                chatbotFlow: "תהליך צ'אטבוט",
                chatbotFlowDesc: "מצב בוט WhatsApp, תורים, שאלות קליטה ואוטומציית משימות",
                chatbotFlowHelp: "הגדר כיצד הבוט אוסף מידע מלקוחות. הגדר תפריטים, שאלות קליטה ויצירת משימות אוטומטית לכל מספר WhatsApp.",
                productSearch: "חיפוש מוצרים",
                productSearchDesc: "מקורות נתונים, סינון מוצרים ומבנה קטגוריות לחיפוש קטלוג",
                productSearchHelp: "חבר את הAI לקטלוג המוצרים/שירותים שלך. הAI יחפש ויציג פריטים רלוונטיים ללקוחות במהלך שיחות.",
                externalCrm: "CRM חיצוני",
                externalCrmDesc: "חיבור למסד נתונים חיצוני (Supabase) לחיפוש לקוחות, סנכרון משימות ותשלומים",
                advanced: "מתקדם",
                advancedDesc: "כללי העברה והגדרות מתקדמות נוספות",
                advancedHelp: "הגדר מתי הAI צריך לעצור ולהעביר את השיחה לנציג אנושי.",
                active: "פעיל"
              },
              crm: {
                enableIntegration: "הפעל חיבור CRM חיצוני",
                connectionTitle: "חיבור",
                connectionHelp: "הזן את כתובת פרויקט Supabase ומפתח API. ניתן למצוא אותם בלוח הבקרה של Supabase תחת Settings → API.",
                supabaseUrl: "כתובת Supabase",
                supabaseKey: "מפתח API של Supabase",
                testConnection: "בדוק חיבור",
                edgeFunctionPath: "נתיב Edge Function (אופציונלי)",
                edgeFunctionPathHelp: "אם מוגדר, שאילתות עוברות דרך Edge Function במקום REST ישיר. דוגמה: /functions/v1/crm-api",
                customerLookupTitle: "חיפוש לקוח",
                customerLookupHelp: "כאשר לקוח שולח הודעת WhatsApp, הבוט יחפש במסד הנתונים לפי מספר טלפון וימלא אוטומטית את הפרטים שלו (שם, כתובת וכו'). כך הבוט לא ישאל שאלות שהתשובות עליהן כבר ידועות.",
                customerLookupDesc: "מילוי אוטומטי של פרטי לקוח ממסד הנתונים כאשר הם שולחים הודעה. מפחית שאלות קליטה.",
                tableName: "שם טבלה",
                tableNameHelp: "שם הטבלה במסד הנתונים שמכילה רשומות לקוחות. דוגמה: customers, contacts, tenants",
                phoneField: "עמודת טלפון",
                phoneFieldHelp: "שם העמודה בטבלה שמאחסנת מספרי טלפון. דוגמה: phone, mobile, tenant_phone",
                nameFields: "עמודות שם",
                nameFieldsHelp: "שמות עמודות מופרדים בפסיק, למשל first_name, last_name",
                extraField1: "שדה נוסף 1 (אופציונלי)",
                extraField1Help: "שדה נוסף למילוי אוטומטי, למשל כתובת, מחלקה, חברה",
                extraField2: "שדה נוסף 2 (אופציונלי)",
                extraField2Help: "שדה נוסף נוסף, למשל דירה, יחידה, מזהה חשבון",
                cachedFields: "שדות לשמירה (מופרדים בפסיק)",
                cachedFieldsHelp: "שדות נוספים מתשובת החיפוש שיש לזכור לשימוש מאוחר יותר (למשל building_id, apartment_id, customer_id). חובה כאשר תבנית המשימה מתייחסת ל-{notes.<field>}.",
                detectedFields: "עמודות שזוהו",
                taskSyncTitle: "סנכרון משימות",
                taskSyncHelp: "סנכרון אוטומטי של משימות שנוצרו על ידי הבוט למסד הנתונים החיצוני. כאשר לקוח משלים טופס קליטה, נוצרת רשומת משימה ב-CRM.",
                taskTable: "טבלת משימות",
                syncTasksToCrm: "סנכרן משימות ל-CRM",
                defaultTaskType: "סוג משימה ברירת מחדל",
                defaultTaskTypeHelp: "ערך שישמש כשאף מילת מפתח לא תואמת. בחר ערך שה-CRM שלך תמיד מקבל (למשל repair, general).",
                requireFields: "שדות חובה (מופרדים בפסיק)",
                requireFieldsHelp: "דלג על קריאת ה-CRM אם אחד מהשדות הללו חסר ברשומות. מונע שגיאות 400 כשחיפוש הלקוח לא מצא התאמה.",
                taskTypeMap: "מיפוי סוגי משימות (JSON)",
                taskTypeMapHelp: 'מיפוי כל task_type שה-CRM שלך מקבל לרשימת מילות מפתח. ההתאמה הראשונה זוכה (substring לא תלוי-רישיות על שם התור). דוגמה: {"emergency": ["leak","fire"], "repair": ["broken","fix"]}',
                payloadTemplate: "תבנית גוף הבקשה ל-create_task (JSON)",
                payloadTemplateHelp: "מבנה הגוף שה-CRM מצפה לו עבור create_task. השתמש ב-{{title}}, {{taskType}}, {{priority}}, {{description}}, {{phone}}, {notes.<field>}. השאר ריק לשימוש בברירת מחדל.",
                advanced: {
                  title: "מתקדם — מיפוי סוג משימה ותבנית",
                  description: "מלא רק אם ה-CRM שלך אוכף enum נוקשה ל-task_type או מבנה גוף בקשה מותאם. ברירות המחדל עובדות לרוב התקנות Supabase.",
                  jsonParseError: "JSON לא תקין",
                  jsonMustBeObject: "ה-JSON חייב להיות אובייקט"
                },
                paymentCheckTitle: "בדיקת תשלום",
                paymentCheckHelp: "מאפשר לבוט לבדוק סטטוס תשלום ממסד הנתונים. כאשר לקוח שואל על תשלומים, הבוט יכול לחפש את היתרה והיסטוריית התשלומים.",
                paymentTable: "טבלת תשלומים",
                paymentStatusField: "עמודת סטטוס"
              },
              companyKnowledge: {
                title: "ידע החברה",
                description: "פרופיל עסקי, חוקים ושאלות נפוצות — מוזרקים להנחיית הAI בכל שיחה עם לקוח.",
                profile: "פרופיל עסקי",
                overview: "סקירה עסקית",
                overviewPlaceholder: "מה החברה עושה, את מי אתם משרתים? (2-3 משפטים)",
                serviceAreas: "אזורי שירות (מופרדים בפסיק)",
                escalationPhone: "טלפון להסלמה",
                escalationEmail: "אימייל להסלמה",
                communication: "סגנון תקשורת",
                addressForm: "צורת פנייה",
                toneStyle: "טון וסגנון",
                stopTopics: "נושאים להימנע מהם (מופרדים בפסיק)",
                disclaimers: "הצהרות נדרשות (מופרדות בפסיק)",
                rules: "חוקי עסק",
                addRule: "הוסף חוק",
                neverDo: "איסורים מוחלטים",
                addNeverDo: "הוסף איסור",
                neverDoPlaceholder: "לעולם אל תדון בתמחור של מתחרים",
                faq: "שאלות נפוצות",
                addFaq: "הוסף שאלה",
                faqQuestion: "שאלה",
                faqAnswer: "תשובה"
              }
            },
            sitePages: {
              sidebarHeading: "עמודים",
              selectPage: "בחר עמוד לעריכה",
              loadError: "טעינת העמודים נכשלה",
              saveSuccess: "העמוד נשמר",
              saveError: "השמירה נכשלה",
              statusError: "עדכון הסטטוס נכשל",
              published: "העמוד פורסם",
              unpublished: "העמוד הועבר לטיוטה",
              statusPublished: "פורסם",
              statusDraft: "טיוטה",
              setDraft: "העבר לטיוטה",
              publish: "פרסם עמוד",
              save: "שמור",
              saving: "שומר…",
              fieldTitle: "כותרת העמוד",
              fieldMetaTitle: "כותרת Meta",
              fieldMetaDesc: "תיאור Meta",
              fieldBody: "תוכן העמוד (HTML)",
              metaTitleHint: "עד 70 תווים. משמש את גוגל ככותרת העמוד בתוצאות החיפוש.",
              metaDescHint: "עד 160 תווים. מוצג מתחת לכותרת בתוצאות החיפוש של גוגל.",
              bodyHint: "תוכן HTML מלא של העמוד. מוצג כמו שהוא ב-whapiz.com.",
              tooLong: "ארוך מדי — גוגל יקצר",
              slugs: {
                termsOfService: "תנאי שימוש",
                privacyPolicy: "מדיניות פרטיות",
                aboutUs: "אודות",
                cookiePolicy: "מדיניות עוגיות"
              }
            }
          }
        }
      };

export { messages };
